/* Français — French */
const fr = {
  nav: {
    home: 'Accueil',
    imageConverter: 'Convertisseur d\'Images',
    imageCompressor: 'Compresseur d\'Images',
    otherTools: 'Autres Outils',
    resizeImage: 'Redimensionner Image',
    cropImage: 'Recadrer Image',
    photoEditor: 'Éditeur Photo',
    removeBackground: 'Supprimer le Fond',
    watermarkImage: 'Filigrane',
    qrCodeGenerator: 'Générateur de Code QR',
    qrCodeScanner: 'Scanner de Code QR',
    aboutUs: 'À Propos',
    faceBlur: 'Flouter le Visage',
  },
  hero: {
    heading: 'Tous les Outils d\'Image dont Vous Avez Besoin',
    subheading: 'Outils en ligne gratuits pour convertir, compresser, redimensionner, recadrer, éditer et transformer vos images. Tout le traitement se fait dans votre navigateur — rapide, privé et sécurisé.',
  },
  tools: {
    compressImage: { title: 'Compresser IMAGE', desc: 'Compressez JPG, PNG, SVG et GIF en économisant de l\'espace et en maintenant la qualité.' },
    resizeImage: { title: 'Redimensionner IMAGE', desc: 'Définissez vos dimensions en pourcentage ou en pixels et redimensionnez vos images.' },
    cropImage: { title: 'Recadrer IMAGE', desc: 'Recadrez JPG, PNG ou GIF facilement.' },
    convertToJpg: { title: 'Convertir en JPG', desc: 'Convertissez des images PNG, GIF, SVG, WEBP en JPG par lots.' },
    convertFromJpg: { title: 'Convertir depuis JPG', desc: 'Convertissez des images JPG en PNG et GIF.' },
    qrCodeGenerator: { title: 'Générateur de Code QR', desc: 'Créez des codes QR personnalisés pour les URL, le texte, le WiFi et les contacts.' },
    qrCodeScanner: { title: 'Scanner de Code QR', desc: 'Scannez les codes QR instantanément avec votre caméra ou en téléchargeant une image.' },
    blurFace: { title: 'Flouter le Visage', desc: 'Détectez et floutez automatiquement les visages dans vos images pour la confidentialité.' },
    removeBackground: { title: 'Supprimer le Fond', desc: 'Supprimez rapidement les arrière-plans d\'images avec une grande précision.' },
    watermarkImage: { title: 'Filigrane IMAGE', desc: 'Apposez une image ou un texte sur vos images en quelques secondes.' },
  },
  whyChoose: {
    label: 'Pourquoi Nous Choisir',
    heading: 'La Manière Plus Intelligente d\'Éditer des Images',
    subheading: 'Des milliers de créateurs, designers et développeurs dans le monde entier nous font confiance.',
    reasons: {
      fast: { title: 'Ultra Rapide', desc: 'Tout le traitement se fait directement dans votre navigateur. Aucun téléchargement vers des serveurs externes.' },
      private: { title: '100% Privé et Sécurisé', desc: 'Vos fichiers ne quittent jamais votre appareil.' },
      noLimits: { title: 'Sans Limites, Sans Inscription', desc: 'Utilisez chaque outil autant de fois que vous le souhaitez — entièrement gratuit.' },
      quality: { title: 'Qualité Professionnelle', desc: 'Nos algorithmes offrent des résultats de qualité professionnelle.' },
      batch: { title: 'Traitement par Lots', desc: 'Gérez plusieurs fichiers à la fois.' },
      everywhere: { title: 'Fonctionne Partout', desc: 'Design entièrement réactif fonctionnant sur ordinateur, tablette et mobile.' },
    },
    stats: {
      imagesProcessed: 'Images Traitées',
      countriesServed: 'Pays Desservis',
      uptime: 'Disponibilité',
      freeTools: 'Outils Gratuits',
    },
  },
  footer: {
    tagline: 'Outils d\'image en ligne gratuits — convertissez, compressez, redimensionnez, recadrez et éditez vos images en quelques secondes. Aucune inscription requise.',
    imageTools: 'Outils d\'Image',
    moreTools: 'Plus d\'Outils',
    company: 'Entreprise',
    contact: 'Contact',
    allRightsReserved: 'Tous droits réservés.',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Questions Fréquemment Posées',
    subheading: 'Réponses rapides aux questions courantes sur cet outil.',
    stillHaveQuestions: 'Encore des questions ? Nous sommes là pour vous aider !',
    reachOut: 'Contactez Notre Équipe',
    questionHeader: 'Question',
  },

  contactForm: {
    badge: 'We contacter',
    title: 'Contactez-nous',
    subtitle: 'Nous serions ravis de vous entendre. Envoyez-nous un message !',
    nameLabel: 'Nom',
    namePlaceholder: 'Votre nom complet',
    emailLabel: 'E-mail',
    emailPlaceholder: 'vous@email.com',
    subjectLabel: 'Objet',
    subjectPlaceholder: 'De quoi s\'agit-il ?',
    messageLabel: 'Message',
    messagePlaceholder: 'Écrivez votre message ici…',
    errName: 'Le nom est obligatoire',
    errEmail: 'L\'e-mail est obligatoire',
    errEmailInvalid: 'Entrez un e-mail valide',
    errSubject: 'L\'objet est obligatoire',
    errMessage: 'Le message est obligatoire',
    sending: 'Envoi en cours…',
    send: 'Envoyer le Message',
    successTitle: 'Message Envoyé !',
    successMsg: 'Merci de nous avoir contacté. Nous vous répondrons bientôt.',
    sendAnother: 'Envoyer un Autre',
    sendError: 'Une erreur s\'est produite. Veuillez réessayer.',
  },

  about: {
    label: 'À Propos',
    heading: 'Conçu pour les Créateurs, par des Créateurs',
    subheading: 'Nous croyons que les outils d\'image puissants doivent être gratuits, rapides et accessibles à tous.',
    missionTitle: 'Notre Mission',
    missionText: 'photremium.com a été créé avec un objectif simple : offrir l\'expérience d\'édition d\'images la plus intuitive, la plus rapide et la plus privée sur le web.',
    privacyTitle: 'Confidentialité d\'Abord',
    privacyText: 'Nous ne téléchargeons, stockons ou traitons jamais vos images sur des serveurs distants.',
    techTitle: 'Technologie Moderne',
    techText: 'Construit avec des technologies web de pointe incluant WebAssembly, Canvas API et React moderne.',
    communityTitle: 'Guidé par la Communauté',
    communityText: 'Chaque fonctionnalité que nous construisons est inspirée par les retours réels des utilisateurs.',
    globalTitle: 'Portée Mondiale',
    globalText: 'Utilisé par des créateurs dans plus de 120 pays.',
  },
  seo: {
    homeTitle: 'photremium.com — Convertisseur, Compresseur et Éditeur d\'Images Gratuit',
    homeDesc: 'Convertissez, compressez, redimensionnez, recadrez et éditez des images en ligne gratuitement.',
    homeKeywords: 'convertisseur d\'images, compresseur d\'images, redimensionner image, éditeur photo',
    aboutTitle: 'À Propos de photremium.com — Notre Mission et Notre Histoire',
    aboutDesc: 'Découvrez photremium.com, la boîte à outils d\'image en ligne gratuite de confiance.',
    aboutKeywords: 'à propos de photremium.com, outils d\'image, éditeur d\'image gratuit',
  },

  privacyPolicyPage: {
    seo: {
      title: 'Politique de Confidentialité — Photremium | Aucun envoi serveur, zéro stockage',
      description: 'La politique de confidentialité de Photremium explique comment nous protégeons vos données. Tout le traitement se fait dans votre navigateur.',
      ogTitle: 'Politique de Confidentialité — Photremium | Aucun upload, zéro stockage',
      ogDescription: 'Vos fichiers restent sur votre appareil. Le traitement est local dans le navigateur.',
      twitterTitle: 'Politique de Confidentialité — Photremium',
      twitterDescription: 'Outils 100% navigateur. Aucun upload, aucun stockage, aucun suivi.',
      schemaName: 'Politique de Confidentialité - Photremium',
      schemaDescription: 'Politique de confidentialité Photremium : aucun envoi serveur, aucun stockage de données.',
    },
    hero: {
      badge: 'Politique de Confidentialité',
      titlePrefix: 'Votre vie privée est notre',
      titleHighlight: 'priorité absolue',
      subPrefix: 'photremium.com repose sur un principe simple —',
      subStrong: 'vos fichiers ne quittent jamais votre appareil',
      subSuffix: 'Tous les outils fonctionnent entièrement dans votre navigateur. Aucun upload. Aucun cloud. Aucun compromis.',
      effectiveLabel: 'Entrée en vigueur',
      lastUpdatedLabel: 'Dernière mise à jour',
      worldwideLabel: 'Applicable dans le monde entier',
    },
    trustCards: [
      { title: 'Aucun upload serveur', desc: 'Vos fichiers ne quittent pas votre appareil. Traitement 100% local.' },
      { title: 'Zéro stockage de données', desc: 'Nous ne stockons rien sur vous, vos images ou votre activité.' },
      { title: 'Aucun suivi', desc: 'Aucun tracking comportemental, aucune empreinte, aucun profilage.' },
      { title: 'Compatible RGPD', desc: 'Conçu pour respecter les réglementations mondiales de confidentialité.' },
    ],
    contentsTitle: 'Sommaire',
    toc: {
      overview: 'Vue d\'ensemble',
      'no-upload': 'Aucun traitement serveur',
      'data-collect': 'Données collectées',
      cookies: 'Cookies et stockage',
      'third-party': 'Services tiers',
      analytics: 'Analytique',
      children: 'Confidentialité des enfants',
      rights: 'Vos droits',
      security: 'Sécurité',
      changes: 'Modifications de la politique',
      contact: 'Contact',
    },
    sections: {
      overview: {
        title: '1. Vue d\'ensemble',
        subtitle: 'Ce que couvre cette politique',
        p1Prefix: 'Cette Politique de Confidentialité décrit comment',
        p1Middle: '("nous", "notre") traite - ou plus exactement,',
        p1Italic: 'ne traite pas',
        p1Suffix: 'vos informations personnelles lorsque vous utilisez nos outils d\'image gratuits sur',
        p2: 'Contrairement aux applications web traditionnelles qui envoient les fichiers vers des serveurs distants, photremium.com utilise des API modernes du navigateur (Canvas API, WebAssembly, WebWorkers) pour effectuer chaque opération localement sur votre appareil. Résultat : aucune transmission de données, aucun stockage, aucun risque.',
        calloutLabel: 'Résumé simple :',
        calloutText: 'Nous ne pouvons pas voir vos images, nous ne le souhaitons pas, et notre technologie est conçue pour que cela n\'arrive jamais.',
      },
      noUpload: {
        title: '2. Aucun traitement serveur — jamais',
        subtitle: 'Comment nos outils fonctionnent réellement',
        introPrefix: 'Chaque outil de photremium.com — convertisseur, compresseur, redimensionnement, suppression d\'arrière-plan, flou visage, filigrane, recadrage et QR — traite vos fichiers',
        introStrong: '100% dans votre navigateur web',
        introSuffix: 'avec JavaScript côté client et WebAssembly.',
        points: [
          { label: 'Aucun fichier n\'est téléversé.', text: 'Lorsque vous sélectionnez un fichier, il est lu par la File API du navigateur et traité en mémoire, jamais envoyé sur le réseau.' },
          { label: 'Aucun serveur ne reçoit votre image.', text: 'Notre CDN fournit uniquement HTML, CSS et JavaScript nécessaires à l\'application, pas vos fichiers.' },
          { label: 'Aucun stockage temporaire.', text: 'Les résultats existent uniquement dans la mémoire du navigateur et sont libérés lorsque vous fermez ou quittez la page.' },
          { label: 'Fonctionne hors ligne.', text: 'La plupart des outils continuent à fonctionner sans internet après le chargement initial.' },
        ],
        callout: 'Vous pouvez le vérifier : ouvrez l\'onglet Réseau dans les outils développeur, sélectionnez une image et confirmez qu\'aucune donnée de fichier n\'est envoyée vers un serveur externe.',
      },
      dataCollect: {
        title: '3. Données que nous collectons (et ne collectons pas)',
        subtitle: 'Transparence complète sur les données',
        headers: { type: 'Type de données', collected: 'Collectées ?', whereWhy: 'Où / pourquoi' },
        rows: [
          { type: 'Vos images / fichiers', badge: 'Jamais', variant: 'green', showX: true, whereWhy: 'Traités entièrement dans votre navigateur — jamais transmis' },
          { type: 'Nom / e-mail', badge: 'Jamais', variant: 'green', showX: true, whereWhy: 'Aucun compte ni inscription requis' },
          { type: 'Adresse IP', badge: 'Minimal', variant: 'gray', showX: false, whereWhy: 'Journaux web standards conservés <= 30 jours, non liés à une identité' },
          { type: 'Type navigateur / OS', badge: 'Minimal', variant: 'gray', showX: false, whereWhy: 'Envoyé automatiquement par le navigateur ; compatibilité seulement' },
          { type: 'Pages vues / clics', badge: 'Agrégé', variant: 'blue', showX: false, whereWhy: 'Analytique anonyme uniquement' },
          { type: 'Préférence de langue', badge: 'Local uniquement', variant: 'blue', showX: false, whereWhy: 'Stocké en localStorage sur votre appareil — jamais envoyé' },
          { type: 'Données de paiement', badge: 'Jamais', variant: 'green', showX: true, whereWhy: 'photremium.com est entièrement gratuit' },
        ],
      },
      cookies: {
        title: '4. Cookies et stockage local',
        subtitle: 'Ce qui est stocké sur votre appareil',
        intro: 'photremium.com n\'utilise pas de cookies publicitaires, de suivi intersite, ni de cookies tiers. Le stockage du navigateur est utilisé uniquement pour les fonctions essentielles.',
        points: [
          { label: 'Préférence de langue', text: 'Stockée dans localStorage pour mémoriser votre langue entre les visites.' },
          { label: 'Préférences thème / UI', text: 'Si vous définissez une préférence d\'affichage, elle reste locale sur votre appareil.' },
          { label: 'Aucun cookie de session.', text: 'photremium.com n\'a pas de système de connexion, donc aucun cookie de session.' },
        ],
        callout: 'Vous pouvez supprimer le stockage local de photremium.com à tout moment depuis les paramètres du navigateur.',
      },
      thirdParty: {
        title: '5. Services tiers',
        subtitle: 'Services externes utilisés et pourquoi',
        intro: 'photremium.com utilise un ensemble minimal de services tiers fiables pour l\'infrastructure et les performances.',
        headers: { service: 'Service', purpose: 'Objectif', dataShared: 'Données partagées', privacyPolicy: 'Politique de confidentialité' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'Hébergement & diffusion CDN', dataShared: 'Adresse IP, en-têtes HTTP (standards)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'Icônes chargées via CDN', dataShared: 'Adresse IP (requête CSS)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'Chargement des polices', dataShared: 'Adresse IP (requête police)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'Nous ne partageons pas vos données avec des annonceurs, courtiers de données ou autres tiers.',
      },
      analytics: {
        title: '6. Analytique',
        subtitle: 'Données agrégées respectueuses de la vie privée',
        introPrefix: 'Pour comprendre quels outils sont les plus utilisés et améliorer le site, nous pouvons collecter des statistiques',
        introStrong: 'agrégées et anonymisées',
        introSuffix: 'comme :',
        points: [
          'Nombre de vues par outil (sans identification utilisateur)',
          'Source de trafic (recherche Google, lien direct) — sans données personnelles',
          'Données géographiques au niveau pays',
          'Type navigateur / appareil pour la compatibilité',
        ],
        calloutLabel: 'Aucune donnée n\'est liée à vous personnellement.',
        calloutText: 'Nous n\'utilisons pas Google Analytics ni Meta Pixel.',
      },
      children: {
        title: '7. Confidentialité des enfants',
        subtitle: 'Conformité à la protection des mineurs',
        p1: 'photremium.com ne collecte pas sciemment d\'informations personnelles auprès des enfants de moins de 13 ans (ou 16 ans dans l\'UE selon le RGPD).',
        p2Prefix: 'Si vous pensez qu\'un enfant a soumis des informations personnelles via notre formulaire, contactez-nous immédiatement à',
        p2Suffix: 'et nous les supprimerons rapidement.',
      },
      rights: {
        title: '8. Vos droits',
        subtitle: 'Droits mondiaux de confidentialité',
        intro: 'Comme photremium.com ne collecte pas d\'informations personnellement identifiables, la plupart des droits s\'appliquent de façon triviale.',
        points: [
          { label: 'Droit d\'accès', text: 'Vous pouvez demander une copie des données détenues à votre sujet.' },
          { label: 'Droit de rectification', text: 'Vous pouvez demander la correction de données inexactes.' },
          { label: 'Droit à l\'effacement', text: 'Vous pouvez demander la suppression de données personnelles (RGPD Art. 17, CCPA).' },
          { label: 'Droit d\'opposition / opt-out', text: 'Vous pouvez refuser l\'analytique future via des outils navigateur.' },
          { label: 'Droit à la portabilité', text: 'Votre travail est téléchargé directement sur votre appareil.' },
        ],
        callout: 'Ces droits s\'appliquent à tous les utilisateurs, quelle que soit la juridiction.',
      },
      security: {
        title: '9. Sécurité',
        subtitle: 'Comment nous protégeons votre expérience',
        intro: 'La donnée la plus sûre est celle qui n\'est jamais collectée.',
        points: [
          { label: 'HTTPS appliqué', text: 'Le trafic entre votre navigateur et notre CDN est chiffré via TLS 1.2+ et HSTS.' },
          { label: 'Content Security Policy (CSP)', text: 'Des en-têtes stricts empêchent XSS et injections de scripts.' },
          { label: 'Audits réguliers des dépendances', text: 'Nous auditons et mettons à jour les paquets npm.' },
        ],
        disclosurePrefix: 'Divulgation responsable',
        disclosureTextPrefix: 'Si vous trouvez un problème de sécurité, écrivez-nous à',
        disclosureTextSuffix: 'et nous répondrons sous 48 heures.',
      },
      changes: {
        title: '10. Modifications de cette politique',
        subtitle: 'Comment nous gérons les mises à jour',
        intro: 'Nous pouvons mettre à jour cette politique pour refléter des changements de pratiques, d\'outils ou d\'exigences légales.',
        points: [
          { label: '"Dernière mise à jour"', text: 'la date en haut de page sera révisée.' },
          { label: 'Changements majeurs', text: 'annoncés via un avis visible sur la page d\'accueil pendant au moins 30 jours.' },
          { label: 'Versions précédentes', text: 'archivées et disponibles sur demande.' },
        ],
        outro: 'L\'utilisation continue de photremium.com après publication des changements vaut acceptation de la politique mise à jour.',
      },
      contact: {
        title: '11. Contact et demandes de données',
        subtitle: 'Contactez-nous au sujet de la confidentialité',
        p1Prefix: 'Pour toute question, préoccupation ou demande formelle liée à cette politique, contactez-nous. Nous visons une réponse sous',
        p1Strong: '5 jours ouvrés',
      },
    },
    footer: {
      privacyQuestionsTitle: 'Questions sur la confidentialité ?',
      privacyQuestionsDesc: 'Envoyez vos questions ou demandes de données et nous répondrons rapidement.',
      versionHistoryTitle: 'Historique des versions',
      v2Label: 'v2.0 — Réécriture majeure',
      v11Label: 'v1.1 — Droits CCPA ajoutés',
      v10Label: 'v1.0 — Politique initiale',
    },
  },

  common: {
    new: 'Nouveau !',
    download: 'Télécharger',
    downloadAll: 'Tout Télécharger',
    upload: 'Importer',
    dragDrop: 'Glissez et déposez les images ici, ou cliquez pour parcourir',
    remove: 'Supprimer',
    reset: 'Réinitialiser',
    apply: 'Appliquer',
    cancel: 'Annuler',
    clear: 'Effacer',
    close: 'Fermer',
    save: 'Enregistrer',
    processing: 'Traitement en cours...',
    noFiles: 'Aucun fichier sélectionné',
    selectFiles: 'Sélectionner des fichiers',
    or: 'ou',
    browseFiles: 'Parcourir les fichiers',
    dropHere: 'Déposez les fichiers ici',
    quality: 'Qualité',
    width: 'Largeur',
    height: 'Hauteur',
    format: 'Format',
    compression: 'Compression',
    preview: 'Aperçu',
    original: 'Original',
    result: 'Résultat',
    before: 'Avant',
    after: 'Après',
    downloadAs: 'Télécharger en tant que :',
    zip: 'ZIP',
    separate: 'Séparé',
    chooseFiles: 'Choisir des fichiers',
    pasteHint: 'Vous pouvez également coller des images avec',
    startOver: 'Recommencer',
    startOverConfirm: 'Supprimer toutes les images et recommencer ?',
    addMoreImages: 'Ajouter plus d\'images',
    addImage: 'Ajouter une image',
    images: 'Images',
    totalSize: 'Taille totale',
    size: 'Taille',
    type: 'Type',
    unsavedEdits: 'Vous avez des modifications non enregistrées. Quitter la page ?',
    compareSlider: 'Curseur de comparaison',
    toggleToolsPanel: 'Afficher/masquer le panneau d\'outils',
    closePanel: 'Fermer le panneau',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    fit: 'Ajuster',
    none: 'Aucun',
  },

  compressor: {
    seo: {
      uploadTitle: 'Compresseur d\'Images — Compresser JPG, PNG, SVG, GIF gratuitement | photremium.com',
      uploadDesc: 'Compressez des images JPG, PNG, SVG et GIF en ligne gratuitement. Fichiers jusqu\'à 80% plus petits.',
      uploadKeywords: 'compresseur d\'images, compresser jpg, compresser png, réduire taille image',
      workspaceTitle: 'Compresser des Images — photremium.com Compresseur d\'Images',
      workspaceDesc: 'Ajustez le niveau de compression et téléchargez des images optimisées.',
      workspaceKeywords: 'compresser images, compression d\'images',
    },
    title: 'Compresseur d\'Images',
    desc: 'Compressez des images JPG, PNG et GIF jusqu\'à 80% plus petites. Rapide et privé.',
    toCompress: 'à compresser',
    compressionForAll: 'Compression pour toutes les images',
    summary: 'Résumé',
    originalSize: 'Taille originale',
    compressed: 'Compressé',
    saved: 'Économisé',
    compressionLabel: 'Compression :',
    compressing: 'Compression…',
    compressDownload: 'Compresser et Télécharger',
    lowQualityWarning: 'Une compression élevée peut réduire sensiblement la netteté de l’image.',
    blog: {
      tocTitle: 'Contenu',
      title: 'Blog du Compresseur d’Images',
      formatsIntro: 'Notre outil prend en charge tous les formats d’image. Vous pouvez donc compresser n’importe quelle image facilement. La liste complète des formats est indiquée ci-dessous :',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Qu’est-ce qu’un compresseur d’images ?',
          paragraphs: [
            'Un compresseur d’images est un outil ou un service en ligne qui réduit la taille du fichier d’une image tout en conservant sa qualité visuelle. Toutefois, une compression excessive peut entraîner une baisse visible de qualité.',
          ],
          listTitle: 'TYPES :',
          bullets: [
            'Compression avec perte : ce type de compression réduit la taille en supprimant certaines données de l’image. La qualité peut baisser, mais la différence est souvent peu visible à l’œil nu.',
            'Compression sans perte : elle réduit la taille du fichier sans altérer la qualité visuelle de l’image.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Pourquoi choisir notre outil ?',
          bullets: [
            'Notre compresseur d’images alimenté par l’IA fonctionne parfaitement sur tous les appareils pour offrir les meilleurs résultats possibles.',
            'Vous pouvez compresser plusieurs images (même plus de 100) en un seul clic.',
            'Aucun envoi vers nos serveurs n’est nécessaire. Toutes les images sont compressées localement dans votre navigateur.',
            'Notre outil est totalement gratuit pour toujours. Vous pouvez aussi le partager avec vos amis.',
            'Vous pouvez choisir le pourcentage de compression selon vos préférences.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Guide étape par étape',
          steps: [
            {
              heading: '1. Sélectionnez la/les image(s) à compresser.',
              bullets: [
                'Glissez-déposez la/les image(s) dans la zone prévue.',
                'Vous pouvez aussi copier-coller la/les image(s) avec (Ctrl + V).',
                'L’explorateur de fichiers est également pris en charge via le bouton de sélection.',
              ],
            },
            {
              heading: '2. Choisissez ensuite le pourcentage de compression.',
              bullets: [
                'Un curseur horizontal vous permet de sélectionner facilement le niveau de compression. Suivez ces plages pour des résultats précis.',
              ],
              table: {
                headers: ['Pourcentage de compression', 'Résultats'],
                rows: [
                  ['1%  à  40%', 'Meilleure qualité'],
                  ['41%  à  60%', 'Qualité normale (recommandé)'],
                  ['61%  à  100%', 'Mauvaise qualité'],
                ],
              },
            },
            {
              heading: '3. Vérifiez l’espace que vous avez économisé.',
              paragraphs: [
                'Toutes les métriques de mémoire sont affichées en temps réel. Vous voyez clairement combien d’espace vous avez gagné et vous pouvez ajuster la compression selon vos besoins.',
              ],
            },
            {
              heading: '4. Sélectionnez l’option de téléchargement via le bouton bascule.',
              bullets: [
                'ZIP : si vous compressez plusieurs images, cette option apparaît. Elle archive toutes les images compressées dans un fichier ZIP (recommandé pour un grand nombre d’images).',
                'Séparé : cette option télécharge toutes les images séparément, sans ZIP unique (recommandé pour un petit nombre, moins de 10).',
              ],
            },
            {
              heading: '5. Compressez et téléchargez l’image.',
              paragraphs: [
                'Ce bouton télécharge automatiquement toutes les images compressées selon l’option de téléchargement choisie.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Avantages du compresseur d’images.',
          bullets: [
            'Réduction des coûts de stockage : compresser des images diminue leur taille et l’espace nécessaire.',
            'Chargement plus rapide : des images plus légères améliorent la vitesse de chargement et l’expérience utilisateur.',
            'Solution à la limite Gmail : Gmail limite les pièces jointes à 25 Mo. La compression permet d’envoyer plus de fichiers.',
            'Partage et transfert plus rapides : les gros fichiers prennent plus de temps. La compression économise du temps et des données, et contourne les limites de certaines plateformes.',
            'Optimisation des présentations : des images non compressées peuvent rendre les présentations lourdes et lentes ; compressées, elles sont plus légères et plus faciles à téléverser.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Formats pris en charge.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Convertisseur d\'Images — Convertir PNG, JPG, WEBP, GIF, SVG gratuitement | photremium.com',
      uploadDesc: 'Convertissez des images entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP. Gratuit et privé.',
      uploadKeywords: 'convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',
      workspaceKeywords: 'convertir images, convertisseur de format',

      routeKeywords: {

        'png-to-jpg': 'png à convertir jpg, png to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-png': 'jpg à convertir png, jpg to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'png-to-webp': 'png à convertir webp, png to webp, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-webp': 'jpg à convertir webp, jpg to webp, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'webp-to-jpg': 'webp à convertir jpg, webp to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'webp-to-png': 'webp à convertir png, webp to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'gif-to-jpg': 'gif à convertir jpg, gif to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'gif-to-png': 'gif à convertir png, gif to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'bmp-to-jpg': 'bmp à convertir jpg, bmp to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'bmp-to-png': 'bmp à convertir png, bmp to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'svg-to-png': 'svg à convertir png, svg to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'svg-to-jpg': 'svg à convertir jpg, svg to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'tiff-to-jpg': 'tiff à convertir jpg, tiff to jpg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'tiff-to-png': 'tiff à convertir png, tiff to png, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-gif': 'jpg à convertir gif, jpg to gif, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'png-to-gif': 'png à convertir gif, png to gif, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-bmp': 'jpg à convertir bmp, jpg to bmp, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'png-to-bmp': 'png à convertir bmp, png to bmp, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'webp-to-gif': 'webp à convertir gif, webp to gif, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-ico': 'jpg à convertir ico, jpg to ico, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'png-to-ico': 'png à convertir ico, png to ico, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'jpg-to-svg': 'jpg à convertir svg, jpg to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'png-to-svg': 'png à convertir svg, png to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'webp-to-svg': 'webp à convertir svg, webp to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'gif-to-svg': 'gif à convertir svg, gif to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'bmp-to-svg': 'bmp à convertir svg, bmp to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

        'tiff-to-svg': 'tiff à convertir svg, tiff to svg, convertisseur d\'images, png en jpg, jpg en png, convertisseur webp',

      },
    },
    title: 'Convertisseur d\'Images',
    desc: 'Convertissez des images entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP et plus.',
    toConvert: 'à convertir',
    convertSettings: 'Paramètres de conversion',
    detected: 'Détecté',
    convertTo: 'Convertir en',
    converting: 'Conversion…',
    convertToFormat: 'Convertir en {format}',
    popularConversions: 'Conversions populaires',
    convertingTo: 'Conversion en',
    all: 'Tout',
  },

  resizer: {
    seo: {
      uploadTitle: 'Redimensionner Image — Mettre à l\'échelle JPG, PNG gratuitement | photremium.com',
      uploadDesc: 'Redimensionnez des images en ligne gratuitement par pixels ou pourcentage.',
      uploadKeywords: 'redimensionner image, changer taille image',
      workspaceTitle: 'Redimensionner des Images — photremium.com',
      workspaceDesc: 'Changez la taille des images en ligne gratuitement.',
      workspaceKeywords: 'redimensionner image',
    },
    title: 'Redimensionner l\'Image',
    desc: 'Définissez les dimensions en pixels, pourcentage, centimètres ou pouces et redimensionnez instantanément.',
    toResize: 'à redimensionner',
    resizeSettings: 'Paramètres de redimensionnement',
    resizeBy: 'Redimensionner par :',
    byPixels: 'Par pixels',
    byPercentage: 'Par pourcentage',
    byCentimeters: 'Par centimètres',
    byInches: 'Par pouces',
    advanced: 'Avancé',
    lockAspect: 'Verrouiller le rapport d\'aspect',
    unlockAspect: 'Déverrouiller le rapport d\'aspect',
    dontEnlarge: 'Ne pas agrandir si l\'original est plus petit',
    resizing: 'Redimensionnement…',
    resizeDownload: 'Redimensionner et Télécharger',
    blog: {
      tocTitle: 'Contenu',
      title: 'Blog de l’Outil de Redimensionnement d’Image',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Pourquoi utiliser un outil de redimensionnement d’image ?',
          paragraphs: [
            'Un redimensionneur d’image est un outil ou un logiciel utilisé pour modifier les dimensions d’une image. Il vous permet d’ajuster la taille de l’image souhaitée en changeant sa hauteur, sa largeur ou les deux. Cet outil est particulièrement utile pour les plateformes sociales qui imposent des restrictions de taille lors de l’envoi ou de la publication d’images.',
          ],
          listTitle: 'Par exemple :',
          bullets: [
            'Publications Instagram : 1080 x 1080px (carré)',
            'Publication Facebook : 1200 x 630px',
            'Publication X (anciennement Twitter) : 1200 x 675px',
            'Story Instagram : 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Pourquoi choisir notre outil de redimensionnement d’image ?',
          paragraphs: [
            'Notre redimensionneur d’image alimenté par l’IA rend le processus précis et extrêmement rapide. Vous pouvez utiliser cet outil facilement sur chaque appareil. Il n’est pas nécessaire d’installer ou de télécharger une application. Tous les services sont disponibles en ligne dans le navigateur de votre choix.',
          ],
          bullets: [
            'Vous pouvez redimensionner plusieurs images (même 100+) à la fois avec notre outil. Si vous avez un appareil performant, vous pouvez redimensionner 400 à 500 images en quelques secondes.',
            'Tout le traitement est effectué dans votre navigateur local. Vous n’avez pas besoin d’envoyer vos images vers nos serveurs. Vos images ne quittent jamais votre appareil. Vous pouvez donc redimensionner vos images personnelles sans risque pour la confidentialité.',
            'Plusieurs unités sont prises en charge pour le redimensionnement.',
            'Vous pouvez conserver le ratio d’aspect original même après redimensionnement, simplement en cochant la case.',
            'Si vous redimensionnez plusieurs images, vous pouvez télécharger les images redimensionnées séparément ou en fichier ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Guide étape par étape',
          steps: [
            {
              heading: 'Tout d’abord, sélectionnez l’image ou les images que vous souhaitez redimensionner. Plusieurs méthodes de sélection sont disponibles.',
              bullets: [
                'Vous pouvez simplement glisser-déposer les images pour les redimensionner.',
                'Le raccourci “Ctrl + V” est également pris en charge pour coller l’image dans la zone de dépôt.',
                'Cliquer sur “Choose Files” ouvre l’explorateur de fichiers. Vous pouvez aussi y sélectionner vos images à redimensionner.',
              ],
            },
            {
              heading: 'Ensuite, vous pouvez choisir une unité de redimensionnement. Actuellement, nous proposons :',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Après le choix de l’unité, ajustez la hauteur et la largeur pour redimensionner l’image. Vous pouvez aussi verrouiller le ratio d’aspect en cochant la case.',
            },
            {
              heading: 'Puis cochez “Don’t enlarge if original is smaller” si vous ne souhaitez pas agrandir l’image au-delà de sa taille d’origine.',
            },
            {
              heading: 'Après cela, sélectionnez l’option de téléchargement.',
              bullets: [
                'Sélectionnez ZIP si vous redimensionnez plusieurs images et souhaitez les télécharger en un seul fichier zip.',
                'Ou sélectionnez “separate” pour télécharger chaque image redimensionnée séparément.',
              ],
            },
            {
              heading: 'Ensuite, cliquez sur “Resize & Download” pour télécharger vos images redimensionnées selon l’option choisie.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Avantages de l’outil de redimensionnement : L’avantage le plus notable est le bon positionnement des images dans les pages web et les publications sur les réseaux sociaux.',
          tocLabel: '4. Avantages de l’outil de redimensionnement',
          bullets: [
            'Amélioration de l’UX : La bonne taille et le bon positionnement des images améliorent fortement l’expérience utilisateur. Placer des images trop grandes ou trop petites sans ajustement entraîne une mauvaise UX.',
            'Support des réseaux sociaux : Plusieurs applications sociales ont leurs propres limites de dimensions pour les images. Notre outil vous aide à redimensionner selon ces dimensions requises.',
            'Design responsive : Si vous êtes développeur et souhaitez créer un design responsive, vous devez redimensionner les images dans plusieurs dimensions pour prendre en charge plusieurs appareils.',
            'Meilleur choix : Au lieu d’étirer ou de recadrer les images, ce qui peut déformer leurs dimensions, le redimensionnement est la meilleure option.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Formats pris en charge : Notre outil vous permet de sélectionner des images de n’importe quel format pour les redimensionner. Voici les formats :',
          tocLabel: '5. Formats pris en charge',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Recadrer Image — Couper JPG, PNG, GIF gratuitement | photremium.com',
      uploadDesc: 'Recadrez des images JPG, PNG et GIF en ligne facilement.',
      uploadKeywords: 'recadrer image, couper jpg, couper png',
      workspaceTitle: 'Recadrer des Images — photremium.com',
      workspaceDesc: 'Recadrez des images en ligne gratuitement.',
      workspaceKeywords: 'recadrer image',
    },
    title: 'Recadrer l\'Image',
    desc: 'Recadrez des images JPG, PNG, GIF et plus avec l\'éditeur visuel.',
    toCrop: 'à recadrer',
    cropSettings: 'Paramètres de recadrage',
    widthPx: 'Largeur (px)',
    heightPx: 'Hauteur (px)',
    positionX: 'Position X (px)',
    positionY: 'Position Y (px)',
    cropTemplate: 'Modèle de recadrage',
    landscape: 'Paysage',
    portrait: 'Portrait',
    square: 'Carré',
    freeform: 'Libre',
    cropping: 'Recadrage…',
    cropDownload: 'Recadrer et Télécharger',
    cropDownloadAll: 'Recadrer tout et télécharger',
    saveNext: 'Enregistrer et Suivant',
    croppedNofTotal: 'Vous avez recadré {n} sur {total} images.',
    downloadN: 'Télécharger {n}',
    blog: {
      tocTitle: 'Contenu',
      title: 'Blog de l’Outil de Recadrage d’Image',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Pourquoi utiliser un outil de recadrage d’image ?',
          paragraphs: [
            'L’outil de recadrage d’image est un logiciel utilisé pour couper l’image dans la forme souhaitée. Il est largement utilisé pour découper une partie nécessaire de l’image et supprimer la partie extérieure indésirable pour n’importe quel usage. Il fournit une zone de recadrage que vous pouvez ajuster à la position où vous souhaitez recadrer.',
          ],
          listTitle: 'Par exemple :',
          bullets: [
            'Découper votre propre image à partir d’une photo de groupe.',
            'Recadrer votre nom à partir d’une liste.',
            'Recadrer la barre de progression d’une capture d’écran complète.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Pourquoi choisir notre outil de recadrage d’image ?',
          paragraphs: [
            'Notre outil de recadrage d’image vous permet de recadrer les images avec précision et très rapidement. Vous devez simplement ajuster la taille de la zone de recadrage à la position que vous voulez découper dans n’importe quelle image. Presque tous les formats d’image sont pris en charge pour la sélection de l’image.',
          ],
          bullets: [
            'Vous pouvez recadrer autant d’images que votre appareil peut en prendre en charge. Si vous avez un appareil très performant, vous pouvez recadrer même plus de 100 images à la fois sans ralentissement ni autres problèmes.',
            'Vos images seront traitées dans votre navigateur local. Pas besoin d’envoyer une image à nos serveurs, donc aucune image ne quitte votre appareil. Vous pouvez recadrer vos images personnelles sans insécurité ni risque.',
            'De nombreux outils signalent une erreur de format d’image invalide. Notre outil de recadrage d’image prend en charge ce problème en supportant presque tous les formats d’image.',
            'Si vous recadrez plusieurs images à la fois, notre outil vous permet de télécharger les images recadrées en ZIP ou en images séparées selon votre préférence.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Guide étape par étape',
          steps: [
            {
              heading: '1. Tout d’abord, sélectionnez l’image que vous souhaitez recadrer. La sélection de plusieurs images à la fois est également prise en charge par notre outil de recadrage d’image.',
              bullets: [
                'Glissez-déposez l’image dans la zone de dépôt pour la recadrer.',
                'Vous pouvez aussi sélectionner l’image via l’explorateur de fichiers en cliquant sur le bouton choisir des fichiers placé dans la zone de recadrage.',
                'Le raccourci Ctrl + V est également pris en charge pour coller les images dans la zone de dépôt.',
              ],
            },
            {
              heading: '2. Ensuite, ajustez la taille et la position de la zone de recadrage sur l’image pour la couper.',
            },
            {
              heading: '3. Vous pouvez aussi ajuster la zone de recadrage en saisissant manuellement les valeurs de hauteur, largeur, position horizontale et position verticale.',
            },
            {
              heading: '4. Vous pouvez aussi utiliser certains modèles prédéfinis :',
              bullets: [
                'Paysage(16:9)',
                'Portrait(9:16)',
                'Carré(1:1)',
              ],
            },
            {
              heading: '5. Ensuite, vous devez sélectionner l’une des options de téléchargement.',
              bullets: [
                'ZIP : Sélectionnez cette option si vous recadrez plusieurs images et souhaitez télécharger toutes les images recadrées sous forme d’un seul fichier.',
                'Séparé : Si vous souhaitez télécharger toutes les images recadrées séparément, sélectionnez cette option depuis le bouton bascule.',
              ],
            },
            {
              heading: '6. Ensuite, cliquez sur le bouton Recadrer et Télécharger pour télécharger toutes vos images recadrées selon vos dimensions prédéfinies.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Avantages de l’Outil de Recadrage d’Image : L’outil de recadrage d’image offre plusieurs avantages dans le monde numérique. Certains sont décrits ci-dessous :',
          tocLabel: '4. Avantages de l’Outil de Recadrage d’Image',
          bullets: [
            'Ajustement des images dans des cadres : L’outil de recadrage d’image vous aide à ajuster correctement les images dans des cadres. Ces cadres peuvent être sur une page web ou sur n’importe quelle plateforme de médias sociaux.',
            'Amélioration de l’UX : Comme le bon placement des images améliore l’expérience utilisateur, l’outil de recadrage d’image aide à améliorer l’UX dans une grande mesure.',
            'Suppression des bordures indésirables : Vous pouvez supprimer toute bordure indésirable d’une image pour l’affiner.',
            'Séparation de l’objet souhaité : Vous pouvez aussi séparer votre image d’une photo de groupe.',
            'Économie de stockage : Le recadrage de l’image permet clairement d’économiser du stockage, car la zone brute de l’image est coupée et seule la partie souhaitée est conservée.',
            'Optimisation des présentations : Puisqu’une présentation normale avec 10 images non recadrées prend presque 30MB de stockage, la même présentation avec des images recadrées peut prendre presque 10MB de stockage.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Formats pris en charge :',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Éditeur de Photos — Modifier des photos gratuitement en ligne | photremium.com',
      desc: 'Modifiez des photos en ligne gratuitement — ajoutez du texte, des effets, des cadres et plus.',
      keywords: 'éditeur de photos, modifier photos en ligne',
    },
    title: 'Éditeur de Photos',
    desc: 'Ajoutez du texte, des effets, des cadres et des autocollants aux images.',
    toEdit: 'à modifier',
    textTypography: 'Texte et Typographie',
    textTypographyDesc: 'Ajoutez du texte personnalisé avec différentes polices, couleurs et ombres.',
    filtersEffects: 'Filtres et Effets',
    filtersEffectsDesc: 'Appliquez des filtres professionnels, ajustez la luminosité, le contraste et la saturation.',
    framesStickers: 'Cadres et Autocollants',
    framesStickersDesc: 'Choisissez de beaux cadres et des autocollants amusants pour améliorer les images.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Supprimer l\'Arrière-plan de l\'Image gratuitement | photremium.com',
      uploadDesc: 'Supprimez les arrière-plans d\'images rapidement et précisément. Gratuit.',
      uploadKeywords: 'supprimer arrière-plan, enlever fond image, fond transparent',
      workspaceTitle: 'Supprimer les Arrière-plans — photremium.com',
      workspaceDesc: 'Supprimez les arrière-plans d\'images gratuitement en ligne.',
      workspaceKeywords: 'supprimer arrière-plan',
    },
    title: 'Supprimer l\'Arrière-plan',
    desc: 'Supprimez les arrière-plans d\'images instantanément. 100% gratuit, fonctionne dans votre navigateur.',
    toRemoveBg: 'Supprimer l\'arrière-plan',
    backgroundRemover: 'Suppresseur d\'arrière-plan',
    processingProgress: 'Progression du traitement',
    processingNImages: 'Traitement de {n} image(s)…',
    allNProcessed: 'Toutes les {n} image(s) traitées !',
    nOfTotalDone: '{n} / {total} terminé',
    fileName: 'Nom de fichier',
    dimensions: 'Dimensions',
    status: 'Statut',
    statusDone: '✓ Terminé',
    statusProcessing: '⏳ Traitement',
    statusError: '✗ Erreur',
    statusPending: '⏸ En attente',
    badgeDone: 'Terminé',
    badgeProcessing: 'Traitement…',
    badgeError: 'Erreur',
    removingBg: 'Suppression de l\'arrière-plan…',
    retry: 'Réessayer',
    downloading: 'Téléchargement…',
    nextImage: 'Image suivante',
  },

  watermark: {
    seo: {
      uploadTitle: 'Ajouter un Filigrane en ligne gratuitement | photremium.com',
      uploadDesc: 'Ajoutez des filigranes texte ou image aux photos. Gratuit et rapide.',
      uploadKeywords: 'filigrane, ajouter filigrane',
      workspaceTitle: 'Ajouter un Filigrane — photremium.com',
      workspaceDesc: 'Ajoutez des filigranes gratuitement en ligne.',
      workspaceKeywords: 'filigrane',
    },
    title: 'Ajouter un Filigrane',
    desc: 'Ajoutez des filigranes texte ou logo aux images.',
    toWatermark: 'pour filigrane',
    watermarkTools: 'Outils de filigrane',
    addText: 'Ajouter du texte',
    addImage: 'Ajouter une image',
    layersN: 'Calques ({n})',
    noLayers: 'Aucun calque ajouté pour l\'instant',
    textLayer: 'Calque de texte',
    imageLayer: 'Calque d\'image',
    watermarkDownloadAll: 'Filigrane et Tout télécharger',
    watermarkDownload: 'Filigrane et Télécharger',
    nextImage: 'Image suivante',
    privateMode: 'Mode privé',
    privateModeOn: 'Mode privé ACTIVÉ : déplacer et mettre à l\'échelle le filigrane uniquement…',
    privateModeHint: 'Activez le mode privé pour ajuster uniquement la position et la taille…',
    privateModeActive: 'Mode privé — déplacer, mettre à l\'échelle et taille de police uniquement',
    selectToEdit: 'Sélectionnez une image ou du texte pour commencer à modifier',
    bold: 'Gras',
    italic: 'Italique',
    underline: 'Souligné',
    bgColor: 'Couleur d\'arrière-plan',
    textColor: 'Couleur du texte',
    alignLeft: 'Aligner à gauche',
    alignCenter: 'Centrer',
    alignRight: 'Aligner à droite',
    opacity: 'Opacité',
    stroke: 'Contour',
    strokeWidth: 'Épaisseur du contour',
    strokeColor: 'Couleur du contour',
    tileRepeat: 'Mosaïque / Répéter',
    tilePattern: 'Motif de mosaïque',
    spacing: 'Espacement',
    snapToCenter: 'Ancrer au centre',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    flipHorizontal: 'Retourner horizontalement',
    flipVertical: 'Retourner verticalement',
    rotateLeft: 'Tourner à gauche',
    rotateRight: 'Tourner à droite',
    cornerRadius: 'Rayon des coins',
    borderStroke: 'Bordure / Contour',
    borderWidth: 'Épaisseur de la bordure',
    color: 'Couleur',
    style: 'Style',
    hide: 'Masquer',
    show: 'Afficher',
    lock: 'Verrouiller',
    unlock: 'Déverrouiller',
    solid: 'Plein',
    dashed: 'Tirets',
    dotted: 'Pointillés',
    double: 'Double',
    tileSingle: 'Simple',
    tile2x2: 'Grille 2×2',
    tile3x3: 'Grille 3×3',
    removeAllConfirm: 'Supprimer toutes les images et filigranes ?',
    dimMismatch: 'Les images téléchargées ont des dimensions différentes. Pour de meilleurs résultats, téléchargez des images avec la même résolution.',
    clearBackground: 'Effacer le fond',
    typeHere: 'Tapez ici...',
    linkCorners: 'Lier les coins',
    separateCorners: 'Séparer les coins',
    blog: {
      tocTitle: 'Sommaire',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Aperçu de l’outil',
          title: 'Comment ajouter un filigrane à vos images en ligne — Le guide complet de l’outil Filigrane de Photremium',
          paragraphs: [
            'Vous venez de terminer la retouche d’une belle photo. Peut-être un produit pour votre boutique, un portrait issu d’une séance client, ou une œuvre numérique peaufinée pendant des heures. Et maintenant vient la question que tout créateur finit par se poser : comment la protéger avant de la partager ?',
            'La réponse la plus courante chez les professionnels est : un filigrane — et pour une bonne raison. Un filigrane bien placé agit comme une signature permanente, rend votre travail traçable et marqué, et complique fortement le vol.',
            'Le problème, c’est que la plupart des outils en ligne sont soit trop lourds, soit bloqués par abonnement, soit produisent un filigrane si envahissant qu’il ruine l’image.',
            'L’outil Filigrane de Photremium a été conçu pour corriger cela. Il fonctionne entièrement dans le navigateur, gratuitement, sans compte, et n’envoie jamais vos fichiers sur un serveur. Tout reste local, tout est rapide, et le niveau de contrôle rivalise avec les logiciels de bureau. Dans ce guide, nous allons vous montrer comment il fonctionne, à qui il s’adresse et comment obtenir les meilleurs résultats, à chaque fois.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Qu’est-ce qu’un filigrane',
          title: 'Qu’est-ce qu’un filigrane et pourquoi est-ce important ?',
          paragraphs: [
            'Avant de plonger dans l’outil, il est utile de comprendre ce que fait un filigrane et pourquoi tant de photographes, designers et créateurs le considèrent indispensable.',
            'Un filigrane est une surcouche visible ajoutée à une image — généralement du texte, un logo ou un symbole de copyright — qui identifie le créateur ou le propriétaire du contenu. Contrairement aux métadonnées (cachées dans le fichier et supprimables en quelques secondes), un filigrane est intégré visuellement à l’image. On ne peut pas simplement le supprimer par clic droit sans dégrader visiblement la qualité.',
          ],
          subSections: [
            {
              title: 'Pourquoi les créateurs utilisent des filigranes',
              paragraphs: [
                'Les raisons pratiques de filigraner vos images se résument à trois points clés.',
              ],
              bullets: [
                'Identification de la propriété. Quand votre travail est partagé sur les réseaux sociaux, Pinterest ou intégré dans des articles, l’attribution d’origine est souvent perdue. Un filigrane garantit que votre nom ou votre marque accompagne l’image.',
                'Dissuasion du vol. La plupart des voleurs d’images cherchent la solution la plus facile. Un filigrane professionnel, bien positionné et légèrement transparent, envoie un signal clair : cette image appartient à quelqu’un qui protège son travail.',
                'Protection des portefeuilles clients. Les photographes qui envoient des prévisualisations avant paiement utilisent des filigranes pour éviter l’usage non autorisé. Un filigrane subtil protège sans nuire à l’évaluation.',
              ],
            },
            {
              title: 'Qui devrait filigraner ses images',
              paragraphs: [
                'Si vous appartenez à l’une des catégories suivantes, filigraner vos images avant de les partager n’est pas optionnel — c’est essentiel :',
              ],
              bullets: [
                'Photographes freelance partageant des galeries avec des clients',
                'Graphistes diffusant des échantillons de portfolio',
                'Vendeurs e-commerce montrant des photos de produits avant licensing',
                'Artistes numériques partageant sur les réseaux sociaux',
                'Blogueurs et créateurs dont les images sont régulièrement réutilisées',
                'Contributeurs de photos stock développant une marque reconnaissable',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Panels du workspace',
          title: 'À l’intérieur de l’outil Filigrane de Photremium : un workspace en trois panneaux pour de vrais workflows',
          paragraphs: [
            'Ce qui distingue l’outil Photremium des filigraneurs basiques, c’est son design de workspace. Au lieu d’un simple “tapez un texte, choisissez la position, terminé”, il propose un layout en trois panneaux, proche des logiciels professionnels — mais entièrement dans le navigateur.',
          ],
          subSections: [
            {
              title: 'Le panneau Canvas de gauche',
              paragraphs: [
                'Le panneau Canvas occupe la plus grande partie de l’écran et affiche l’image avec le filigrane en temps réel. Chaque modification — opacité, position du texte, taille du logo — se répercute instantanément. Pas de bouton “aperçu”. Ce que vous voyez est ce que vous obtenez.',
                'Le canvas inclut une barre de zoom pour un alignement précis. Le zoom-to-fit calcule automatiquement l’échelle optimale selon la taille de votre écran. Des guides d’alignement apparaissent lorsque vous approchez le centre horizontal ou vertical, et “snap” le filigrane au centre avec une précision digne de Photoshop.',
              ],
            },
            {
              title: 'Le panneau de réglages à droite',
              paragraphs: [
                'Le panneau droit est le centre de contrôle. Il permet de gérer les couches, personnaliser leur apparence et lancer l’export. Sur desktop, il est fixé à droite. Sur mobile, il apparaît en feuille inférieure via un bouton flottant, sans couvrir le canvas.',
                'À l’intérieur, le gestionnaire de couches liste chaque élément ajouté. Chaque entrée montre le type (texte ou image), le nom ou contenu, et trois actions rapides : visibilité (icône œil), verrouillage et suppression.',
              ],
            },
            {
              title: 'La bande de prévisualisation à gauche (mode multi-image)',
              paragraphs: [
                'Lorsque vous travaillez sur plusieurs images — par exemple des photos produit ou une séance complète — une bande verticale de miniatures apparaît à l’extrême gauche. C’est la file d’images. Cliquer sur une miniature bascule instantanément le canvas sur cette image, sans perdre vos réglages.',
                'La bande affiche aussi la taille en KB/MB et le format (JPG, PNG, WEBP), pour savoir exactement ce que vous traitez.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Étapes',
          title: 'Étape par étape : comment ajouter un filigrane avec Photremium',
          paragraphs: [
            'Ce guide suit le fonctionnement réel de l’outil — depuis l’upload drag-and-drop jusqu’au rendu Canvas avant téléchargement.',
          ],
          steps: [
            {
              heading: 'Étape 1 — Téléverser vos images',
              paragraphsBefore: [
                'Rendez-vous sur photremium.com/watermark-image. Vous arriverez sur l’écran d’upload avec une zone de dépôt au centre.',
                'Vous avez trois façons d’importer vos images :',
              ],
              bullets: [
                'Drag and drop. Glissez-déposez un ou plusieurs fichiers. L’outil accepte JPEG, PNG, WEBP et plus. En survolant, une bordure violette s’affiche avec “Drop images to add for watermarking”.',
                'Cliquer pour parcourir. Cliquez sur “Choose Files” pour ouvrir le sélecteur. Vous pouvez sélectionner plusieurs fichiers avec Ctrl+Click (Windows) ou Cmd+Click (Mac).',
                'Coller depuis le presse-papiers. Si vous avez copié une image, appuyez sur Ctrl+V (Cmd+V sur Mac). Cela fonctionne même si plusieurs images sont déjà chargées.',
              ],
              paragraphsAfter: [
                'Dès que la première image est chargée, l’interface passe au workspace complet et le canvas s’affiche à un zoom adapté.',
              ],
            },
            {
              heading: 'Étape 2 — Ajouter un filigrane texte',
              paragraphsBefore: [
                'Cliquez sur le bouton violet “Add Text” dans le panneau droit. Un nouveau calque texte apparaît avec “Type here...” sélectionné.',
                'Vous pouvez commencer à taper immédiatement. Le texte s’affiche en direct. La toolbar supérieure permet de régler :',
              ],
              bullets: [
                'Font family — 12 polices intégrées comme Arial, Georgia, Impact, Brush Script MT, Comic Sans MS, etc.',
                'Font size — saisir une valeur en px ou utiliser les contrôles',
                'Bold, italic, underline — combiner les styles',
                'Text color — choisir n’importe quelle couleur',
                'Background color — arrière-plan coloré pour badge/étiquette',
                'Stroke (outline) — contour pour meilleure lisibilité',
                'Opacity — de 0% à 100%, souvent 30–60%',
                'Alignment — gauche, centre, droite',
                'Rotation — rotation libre avec snaps à 0°, 90°, 180°, 270°',
              ],
              paragraphsAfter: [
                'Pour déplacer le texte, faites glisser. Pour un placement précis, utilisez les flèches (Shift pour 10 px). Pour redimensionner, utilisez les 8 poignées.',
              ],
            },
            {
              heading: 'Étape 3 — Ajouter un filigrane image (logo)',
              paragraphsBefore: [
                'Si vous préférez un logo ou une signature, cliquez “Add Image” dans le panneau droit et choisissez le fichier. L’outil le redimensionne automatiquement à environ 30% de la largeur et le centre.',
                'Ensuite, vous pouvez le déplacer, redimensionner via les coins (proportions conservées) et le tourner. Pour les calques image, des réglages supplémentaires sont disponibles :',
              ],
              bullets: [
                'Opacity — idem pour les textes, idéal pour logos PNG',
                'Flip horizontal / Flip vertical — miroir',
                'Border width, border color, border style — bordure visible',
                'Border radius — coins arrondis uniformes ou séparés',
                'Rotation — même comportement fluide que pour le texte',
              ],
            },
            {
              heading: 'Étape 4 — Configurer le tuilage (optionnel)',
              paragraphsBefore: [
                'L’une des fonctions puissantes est le tuilage — répéter le filigrane sur toute l’image en grille. Idéal pour empêcher la réutilisation.',
                'Avec un calque sélectionné, choisissez :',
              ],
              bullets: [
                'None — placement unique (par défaut)',
                'Grid 2×2 — répète en 2x2',
                'Grid 3×3 — répète en 3x3',
              ],
              paragraphsAfter: [
                'Vous pouvez ajuster l’espacement pour contrôler la densité. Le canvas affiche des copies fantômes en prévisualisation.',
              ],
            },
            {
              heading: 'Étape 5 — Utiliser le gestionnaire de couches',
              paragraphsBefore: [
                'Vous pouvez ajouter autant de calques que vous voulez. Le gestionnaire liste tout. Vous pouvez :',
              ],
              bullets: [
                'Afficher/masquer un calque via l’icône œil',
                'Verrouiller un calque pour éviter les déplacements',
                'Supprimer un calque',
              ],
              paragraphsAfter: [
                'Cliquer sur un calque dans la liste le sélectionne sur le canvas pour édition rapide.',
              ],
            },
            {
              heading: 'Étape 6 — Basculer entre plusieurs images',
              paragraphsBefore: [
                'Si vous avez importé plusieurs images, utilisez la bande de miniatures à gauche. Vos calques s’appliquent à toutes les images lors de l’export.',
                'L’outil détecte aussi les différences de résolution. Au-delà de 5%, un avertissement apparaît. La position est recalculée proportionnellement pour garder un rendu cohérent.',
              ],
            },
            {
              heading: 'Étape 7 — Choisir les préférences de téléchargement',
              paragraphsBefore: [
                'Pour un seul fichier, cliquez “Download” sous le canvas. Le nom de fichier reçoit “-watermarked”. Les JPEG sont exportés en 0.95, les PNG restent lossless.',
                'Pour des lots, deux modes sont disponibles dans le panneau droit :',
              ],
              bullets: [
                'ZIP — toutes les images dans un ZIP',
                'Separate — chaque image est téléchargée séparément',
              ],
            },
            {
              heading: 'Étape 8 — Télécharger et vérifier',
              paragraphsBefore: [
                'Au téléchargement, l’outil rend chaque image sur une canvas cachée à pleine résolution — pas à l’échelle de prévisualisation. Vous obtenez la taille originale avec un filigrane correctement proportionné. Ouvrez le fichier et zoomez pour vérifier.',
                'Si quelque chose ne va pas, revenez, ajustez et téléchargez à nouveau.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Conseils pro',
          title: 'Conseils pro pour de meilleurs résultats',
          bullets: [
            'Utilisez un logo PNG semi-transparent pour un rendu pro. Un logo à 40–50% d’opacité paraît plus élégant qu’un texte plein.',
            'Placez le filigrane là où le recadrage enlève de la valeur. Le coin inférieur droit est le plus courant — et le plus facile à découper. Pour plus de protection, placez-le sur une zone clé. Le tuilage diagonal est encore plus difficile à retirer.',
            'Utilisez le verrouillage quand vous travaillez avec plusieurs calques. Une fois la position principale fixée, verrouillez-la avant d’ajouter d’autres éléments.',
            'Testez les zones claires et sombres. Un filigrane blanc disparaît sur un ciel clair mais est lisible sur les ombres. Ajoutez un léger contour ou fond pour la lisibilité.',
            'Les raccourcis clavier font gagner du temps. Les flèches déplacent de 1 px, Shift+Arrow de 10 px. Delete supprime le calque instantanément.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Confidentialité',
          title: 'Confidentialité et sécurité : pourquoi le traitement dans le navigateur est important',
          paragraphs: [
            'Une inquiétude fréquente avec les outils en ligne est : où vont réellement les images ? Avec les outils basés sur serveur, l’image est envoyée, traitée puis renvoyée. Vos travaux non publiés passent donc par une infrastructure tierce.',
            'L’outil Photremium traite tout localement dans votre navigateur. Vos images sont chargées en mémoire via File API et ne sont jamais transmises. Le rendu se fait via HTML5 Canvas dans l’onglet. Quand vous fermez la page ou cliquez “Start Over”, les données sont libérées. Rien n’est stocké en dehors de votre appareil.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Résumé final',
          title: 'Pourquoi l’outil Filigrane de Photremium mérite une place régulière dans votre workflow',
          paragraphs: [
            'Il existe des dizaines d’outils de filigranage. Ce qui différencie un outil utile d’un outil oubliable, c’est souvent un mélange de vitesse, de contrôle et de confiance.',
            'La vitesse compte parce que filigraner ne doit pas ralentir votre flux. Photremium se charge instantanément, traite localement et exporte en pleine résolution en quelques secondes — même sur de gros lots. Pas d’attente serveur, pas de file, pas de délai lié au trafic.',
            'Le contrôle compte parce qu’un mauvais filigrane est pire que pas de filigrane. Le système de calques, les réglages par propriété, l’aperçu en direct et les raccourcis offrent un niveau de contrôle comparable à un logiciel de bureau.',
            'La confiance compte parce que votre travail non publié a de la valeur. Savoir que vos images ne quittent jamais votre appareil permet de traiter des photos clients, des produits non lancés ou des contenus sensibles sans inquiétude.',
            'Que vous ajoutiez un avis de copyright à une photo ou traitiez 200 images pour un client, l’outil Photremium vous permet de le faire correctement — gratuitement, en privé et avec suffisamment de flexibilité pour que le filigrane paraisse naturel.',
            'Rendez-vous sur photremium.com/watermark-image et essayez. Votre première image filigranée est littéralement à trente secondes.',
            'Photremium propose une suite d’outils d’image dans le navigateur. Tous fonctionnent localement — vos images restent sur votre appareil.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Générateur de QR Code — Créer et personnaliser gratuitement | photremium.com',
      inputDesc: 'Créez des QR codes personnalisés pour des URLs, texte, WiFi, contacts, e-mail et Google Maps.',
      inputKeywords: 'générateur qr code, créer qr code',
      customizeTitle: 'Personnaliser QR Code — photremium.com',
      customizeDesc: 'Personnalisez le style, la couleur, le cadre et le logo du QR code.',
      customizeKeywords: 'personnaliser qr code, couleurs qr code',
    },
    title: 'Générateur de QR Code',
    desc: 'Générez, personnalisez et téléchargez des QR codes pour URLs, texte, WiFi, contacts, e-mail et maps.',
    generate: 'Générer',
    scanQrCode: 'Scanner le QR code',
    tabUrl: 'Lien / URL',
    tabText: 'Texte',
    tabWifi: 'WiFi',
    tabContact: 'Contact',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Entrez l\'URL',
    enterText: 'Entrez le texte',
    networkName: 'Nom du réseau (SSID)',
    password: 'Mot de passe',
    encryption: 'Chiffrement',
    hiddenNetwork: 'Réseau caché',
    contactName: 'Nom du contact (optionnel)',
    phoneNumber: 'Numéro de téléphone',
    emailAddress: 'Adresse e-mail',
    subject: 'Sujet (optionnel)',
    body: 'Corps (optionnel)',
    searchLocation: 'Rechercher un lieu',
    urlPlaceholder: 'https://exemple.fr',
    textPlaceholder: 'Entrez le texte ici…',
    wifiNamePlaceholder: 'Mon WiFi',
    passwordPlaceholder: 'Mot de passe',
    contactPlaceholder: 'Jean Dupont',
    phonePlaceholder: '+33 X XX XX XX XX',
    emailPlaceholder: 'exemple@gmail.com',
    subjectPlaceholder: 'Sujet',
    bodyPlaceholder: 'Corps de l\'e-mail…',
    locationPlaceholder: 'Rechercher une ville, adresse, lieu…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Aucun',
    characters: 'caractères',
    qrGettingComplex: 'Le QR code devient complexe — peut être difficile à scanner.',
    qrTooComplex: 'QR code trop complexe ! La plupart des scanners ne pourront pas le lire.',
    generateCustomize: 'Générer et Personnaliser',
    editQrData: 'Modifier les données QR',
    styleShape: 'Style et Forme',
    colorTab: 'Couleur',
    framesTab: 'Cadres',
    logoTab: 'Logo',
    templatesTab: 'Modèles',
    fileFormatTab: 'Format de fichier',
    dotShape: 'Forme des points',
    cornerEyeOuter: 'Œil de coin — Extérieur',
    cornerEyeInner: 'Œil de coin — Intérieur',
    fgColor: 'Couleur de premier plan',
    bgColor: 'Couleur d\'arrière-plan',
    enableGradient: 'Activer le dégradé',
    gradientType: 'Type de dégradé',
    linear: 'Linéaire',
    radial: 'Radial',
    gradientColor1: 'Couleur de dégradé 1',
    gradientColor2: 'Couleur de dégradé 2',
    suggestedGradients: 'Dégradés suggérés',
    selectFrame: 'Sélectionner un cadre',
    selectLogo: 'Sélectionner un logo',
    uploadCustomLogo: 'Ou téléchargez un logo personnalisé',
    uploadImage: 'Télécharger une image',
    customLogoApplied: 'Logo personnalisé appliqué',
    premadeTemplates: 'Modèles préfabriqués',
    templateHint: 'Cliquez sur un modèle pour appliquer instantanément sa combinaison de style.',
    downloadFormat: 'Format de téléchargement',
    fgBgIdentical: 'Les couleurs de premier plan et d\'arrière-plan sont identiques — le QR code sera invisible !',
    fgBgSimilar: 'Les couleurs de premier plan et d\'arrière-plan sont très similaires — le QR code peut être difficile à scanner.',
    preview: 'Aperçu',
    angle: 'Angle',
    downloadFormatBtn: 'Télécharger {format}',
    pngDesc: 'Sans perte, support de transparence',
    jpgDesc: 'Format de fichier populaire/universel',
    webpDesc: 'Format moderne, meilleur rapport qualité/taille',
    svgDesc: 'Graphiques vectoriels évolutifs',
    pdfDesc: 'Document prêt à imprimer',
    lat: 'Latitude :',
    lng: 'Longitude :',
    qrCode: 'QR Code',
    scanMe: 'SCANNEZ-MOI',
    scanHere: 'SCANNEZ ICI',
    blog: {
      card1: {
        title: '1. Qu’est-ce qu’un code QR ?',
        intro1: 'La signification complète de QR est “Quick Response code” (code à réponse rapide). Comme les informations qu’il contient sont décodées très rapidement, on l’appelle code QR.',
        intro2: 'Le code QR est un code numérique bidimensionnel lisible uniquement par les machines. Les données qu’il contient ne peuvent pas être lues directement par un humain. Il contient des blocs pour stocker des informations comme du texte, des numéros de contact, des liens et des emplacements Google Maps, etc.',
        inventionTitle: 'Comment le code QR a été inventé :',
        inventionText: 'Le code QR a été inventé en 1994. Masahiro Hara et son équipe travaillaient dans une entreprise japonaise appelée Denso Wave, qui fabriquait des pièces automobiles pour Toyota. Ils voulaient un code pouvant stocker beaucoup plus d’informations qu’un code-barres classique, et ils ont alors inventé le code QR.',
        keyFeaturesTitle: 'Caractéristiques clés d’un code QR',
        keyFeatures: [
          {
            title: 'Comment fonctionne le QR',
            text: 'Vous saisissez le texte ou le lien pour générer son code QR. Le générateur crée des carrés selon l’information. Chaque carré représente un bit, et chaque bit stocke un caractère.',
          },
          {
            title: 'Structure du code QR',
            text: 'Un code QR contient trois grands carrés pour identifier son orientation, et de petits carrés pour stocker les bits (informations).',
          },
          {
            title: 'Capacité de données du code QR',
            text: 'En général, un code QR stocke plus d’informations qu’un code-barres. Le code QR est simplement une version avancée du code-barres, en 2 dimensions. Un code QR stocke presque 200 caractères. Il peut aussi stocker 400 caractères, mais cela peut être difficile à scanner. Stocker plus de 400 caractères peut produire un code QR très complexe qui ne pourra, dans la plupart des cas, pas être lu.',
          },
          {
            title: 'Détection d’erreurs dans les codes QR',
            text: 'Un code QR peut encore être scannable si certaines informations sont rayées ou si certains bits sont inversés. Le code QR utilise la technique de détection/correction Reed-Solomon pour identifier puis corriger les erreurs.',
          },
        ],
        errorTitle: 'Niveau de correction d’erreurs du code QR :',
        errorIntro: 'Différentes techniques de détection et de correction d’erreurs sont utilisées selon les cas, comme indiqué ci-dessous :',
        errorHeaders: {
          level: 'Niveau',
          recovery: 'Capacité de récupération',
          bestUse: 'Meilleur cas d’usage',
        },
        errorRows: [
          {
            level: 'Faible (L)',
            recovery: '~7%',
            useCases: [
              'Cette technique est utilisée lorsque le code QR est affiché sur des écrans numériques, des sites web, ou dans un environnement propre.',
              'Quand un code QR est généré pour de petites informations comme Gmail, un numéro de contact ou un court texte.',
            ],
          },
          {
            level: 'Moyen (M)',
            recovery: '~15%',
            useCases: [
              'Pour les flyers et affiches installés dans un environnement propre, lorsque le risque de dommage est négligeable.',
            ],
          },
          {
            level: 'Quartile (Q)',
            recovery: '~25%',
            useCases: [
              'Quand le code QR doit être installé dans un environnement difficile comme une usine ou l’extérieur.',
              'Aussi, lorsqu’un petit logo est placé au centre, il couvre certains bits. Ce niveau de correction est alors nécessaire.',
            ],
          },
          {
            level: 'Élevé (H)',
            recovery: '~30%',
            useCases: [
              'Utilisé lorsqu’un dommage important du code QR est possible.',
              'Quand de grands logos couvrent le centre du code QR.',
              'Aussi, lorsqu’un style visuel important est appliqué au code QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Pourquoi choisir notre générateur de code QR ?',
        intro: 'Notre générateur de code QR rend la création de QR extrêmement rapide, sécurisée et simple. Vous pouvez personnaliser votre code pour le rendre plus avancé, professionnel et adapté à l’identité de votre activité. Toutes les personnalisations, de la couleur à l’ajout de logo, sont offertes gratuitement pour toujours.',
        strengths: [
          {
            title: 'Personnalisation professionnelle :',
            text: 'Vous pouvez générer et personnaliser autant de codes QR que nécessaire sans aucun coût. Toutes les fonctionnalités sont entièrement gratuites. Vous pouvez appliquer des dégradés, différentes formes de modules, des logos personnalisés et bien d’autres options.',
          },
          {
            title: 'Prise en charge de plusieurs formats :',
            text: 'Notre générateur propose plusieurs formats de téléchargement pour votre confort. Il suffit de choisir le format avant le téléchargement. Nous proposons actuellement ces formats :',
          },
          {
            title: 'Modèles préconçus :',
            text: 'Vous pouvez utiliser des dégradés et des cadres préconçus qui rendent votre code QR plus professionnel.',
          },
          {
            title: 'Support de logo personnalisé :',
            text: 'Vous pouvez aussi importer le logo de votre marque, qui s’ajuste automatiquement au centre du code QR. Vous pouvez également choisir un logo depuis la bibliothèque intégrée, qui contient plus de 30 logos.',
          },
          {
            title: 'Aperçu en direct :',
            text: 'Pendant la personnalisation, vous pouvez voir tous les changements dans un panneau d’aperçu en temps réel.',
          },
          {
            title: 'Indicateur de scan :',
            text: 'Lors du choix des couleurs, des avertissements et indicateurs vous guident si vous sélectionnez des couleurs difficiles à scanner.',
          },
        ],
        formatHeaders: {
          srNo: 'N°',
          formats: 'Formats',
          description: 'Description',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Sans perte, prise en charge de la transparence' },
          { no: '2', format: 'JPG', description: 'Format de fichier populaire et universel' },
          { no: '3', format: 'WEBP', description: 'Format moderne, meilleur rapport qualité/taille' },
          { no: '4', format: 'SVG', description: 'Graphique vectoriel redimensionnable' },
          { no: '5', format: 'PDF', description: 'Document prêt à imprimer' },
        ],
      },
      card3: {
        title: '3. Guide étape par étape :',
        step1Intro: 'Tout d’abord, sélectionnez la catégorie du code QR que vous souhaitez générer. Que vous génériez un QR pour contact, carte, lien ou texte. Actuellement, notre générateur propose ces catégories :',
        categories: ['Lien / URL', 'Texte', 'WiFi', 'Contact', 'Gmail', 'Google Maps'],
        step2: 'Après avoir sélectionné la catégorie, collez vos informations dans le champ texte correspondant.',
        step3Intro: 'Ensuite, cliquez sur Générer et Personnaliser pour ouvrir le panneau de personnalisation. Dans ce panneau, vous verrez une sous-navigation avec les options suivantes :',
        options: [
          {
            title: 'Style et forme :',
            text: 'Dans cette section, vous pouvez changer la forme des modules en plusieurs styles comme coins arrondis, points, barres horizontales, barres verticales, petits carrés et bien d’autres.',
          },
          {
            title: 'Couleur :',
            text: 'Vous pouvez choisir vos couleurs d’arrière-plan et d’avant-plan dans cette section. Pour créer un QR en dégradé, vous pouvez activer le mode dégradé, appliquer un dégradé depuis la bibliothèque intégrée ou créer le vôtre facilement. Vous pouvez aussi changer l’angle du dégradé linéaire. Le dégradé radial est également pris en charge. Vous pouvez ajouter plusieurs couleurs pour créer un effet professionnel.',
          },
          {
            title: 'Cadres :',
            text: 'Ici, vous pouvez sélectionner un cadre parfait pour votre code QR. Tous les cadres s’ajustent automatiquement à votre code. Vous devez simplement choisir un cadre dans la bibliothèque intégrée.',
          },
          {
            title: 'Logo :',
            text: 'Après sélection du cadre, vous pouvez choisir un logo qui sera automatiquement ajusté au centre du code QR. L’import de votre logo de marque est également pris en charge.',
          },
          {
            title: 'Modèles :',
            text: 'Si vous ne souhaitez pas sélectionner séparément style, forme, couleur et cadre, vous pouvez appliquer des modèles préconçus sur votre code QR. Plusieurs modèles premium sont fournis gratuitement pour toujours.',
          },
          {
            title: 'Format de fichier :',
            text: 'Enfin, vous devez sélectionner le type de fichier dans lequel vous souhaitez télécharger le code QR. Plusieurs formats courants sont pris en charge, notamment PNG, WEBP, SVG et PDF, etc.',
          },
          {
            title: 'Modifier les données QR :',
            text: 'Vous pouvez aussi modifier vos données QR sans perdre les personnalisations choisies.',
          },
        ],
        finalStep: 'Ensuite, cliquez simplement sur le bouton de téléchargement, et le code QR, exactement selon vos personnalisations et dans le format sélectionné, sera téléchargé instantanément sans aucun coût.',
      },
      card4: {
        title: '4. Avantages :',
        intro: 'Le code QR relie le monde physique à l’expérience numérique. C’est le moyen le plus rapide de partager des liens, un contact ou votre localisation. Il suffit de scanner ce code QR pour accéder instantanément aux informations. C’est pourquoi il est très populaire dans les entreprises et le monde digital : il fait gagner du temps et reste très utile.',
        benefits: [
          {
            title: 'Support à vie :',
            text: 'Les codes QR fonctionnent pour toujours sans expiration. Ils vous donnent instantanément les informations stockées lorsque vous les scannez. Comme ils stockent des instructions numériques codées en dur, ils ne perdent jamais leurs informations.',
          },
          {
            title: 'Support hors ligne :',
            text: 'Vous pouvez scanner le code QR même hors ligne. La caméra de votre mobile décode les motifs du code QR et vous donne les informations qu’il contient.',
          },
          {
            title: 'Coût zéro :',
            text: 'Comme ces codes ne nécessitent ni redirection serveur ni ressources supplémentaires, ils sont gratuits pour toujours.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Scanner de QR Code — Scanner avec caméra ou image | photremium.com',
      desc: 'Scannez des QR codes instantanément avec la caméra ou téléchargez une image. Rapide, privé et sécurisé.',
      keywords: 'scanner qr, scanner qr code, lecteur qr',
    },
    title: 'Scanner de QR Code',
    desc: 'Scannez des QR codes instantanément avec la caméra ou téléchargez une image. Rapide, privé et sécurisé.',
    generateQrCode: 'Générer un QR code',
    scan: 'Scanner',
    cameraScanner: 'Scanner par caméra',
    uploadImage: 'Télécharger une image',
    pointCamera: 'Pointez la caméra vers un QR code',
    startCamera: 'Démarrer la caméra',
    loading: 'Chargement…',
    dropQrImage: 'Déposez l\'image QR code ici',
    toScan: 'à scanner',
    supportedFormats: 'Compatible JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Ctrl+V pour coller',
    scanFromGallery: 'Scanner depuis la galerie',
    instantScanning: 'Scan instantané',
    instantScanningDesc: 'Reconnaissance de QR code en temps réel depuis caméra ou images téléchargées',
    private100: '100% Privé',
    private100Desc: 'Tout le traitement se fait dans votre navigateur. Rien n\'est téléchargé',
    multiFormat: 'Multi-format',
    multiFormatDesc: 'Détecte URLs, texte, WiFi, contacts, e-mail, téléphone et plus',
    accessingCamera: 'Accès à la caméra…',
    cameraDenied: 'Accès caméra refusé. Veuillez autoriser la permission caméra et réessayer.',
    noCamera: 'Aucune caméra trouvée sur cet appareil.',
    cameraError: 'Impossible d\'accéder à la caméra. Réessayez.',
    videoError: 'Impossible de démarrer la lecture vidéo.',
    switchError: 'Impossible de changer de caméra.',
    tryAgain: 'Réessayer',
    switchCamera: 'Changer de caméra',
    stop: 'Arrêter',
    noQrFound: 'Aucun QR code trouvé',
    couldNotRead: 'Impossible de lire l\'image',
    scannerFailed: 'Échec du chargement du scanner',
    noQrFoundDesc: 'Aucun QR code détecté dans l\'image. Essayez une autre image ou utilisez le scanner caméra.',
    qrScanned: 'QR code scanné !',
    openLink: 'Ouvrir le lien',
    copied: 'Copié !',
    copy: 'Copier',
    share: 'Partager',
    scanAgain: 'Scanner à nouveau',
    network: 'Réseau',
    password: 'Mot de passe',
    security: 'Sécurité',
    unknown: 'Inconnu',
    typeText: 'Texte',
    typeUrl: 'URL',
    typeWifi: 'Réseau WiFi',
    typeContact: 'Fiche contact',
    typeEmail: 'E-mail',
    typePhone: 'Numéro de téléphone',
    typeSms: 'SMS',
    typeLocation: 'Localisation',
    blog: {
      tocTitle: 'Sommaire',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Pourquoi utiliser un scanner de QR code ?',
          paragraphs: [
            'Un scanner de QR code est essentiellement une caméra mobile qui décode les informations stockées dans le QR code. Il vous suffit de pointer la caméra vers le QR code ; quelle que soit son orientation, il lit les motifs spécifiques, détecte les erreurs, corrige les erreurs si nécessaire, puis affiche les informations qu’il contient.',
          ],
          listTitle: 'Types de scanners de QR code :',
          bullets: [
            'Scanner de QR code basé sur le web : Vous pouvez scanner un QR code avec des scanners en ligne pris en charge par votre navigateur. Vous pouvez accéder aux informations via la caméra ou en téléversant une image. Pour la redirection automatique et d’autres fonctionnalités avancées, vous pouvez visiter https://photremium.com.',
            'Caméras mobiles : Certains téléphones modernes disposent d’un scanner de QR code intégré à leur application caméra native. Ils peuvent récupérer et décoder les informations simplement en scannant le QR code avec la caméra.',
            'Applications : Certaines applications sont conçues spécifiquement pour scanner les QR codes. Cependant, pour une redirection avancée et de nombreuses autres fonctionnalités, vous pouvez installer l’application gratuitement via ce lien : https://photremium.com.',
            'Appareils matériels : Certains appareils matériels sont également conçus pour scanner les QR codes. Ces appareils sont largement utilisés dans les grands centres commerciaux pour la facturation des articles.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Pourquoi choisir notre scanner de QR code ?',
          paragraphs: [
            'Vous pouvez découvrir plusieurs fonctionnalités avancées, de la redirection à la copie du contenu décodé depuis le QR code. Vous pouvez explorer de nombreuses autres fonctionnalités intéressantes de notre scanner de QR code, telles que :',
          ],
          bullets: [
            'Vitesse rapide : Notre scanner de QR code rend le décodage extrêmement rapide. Il vous suffit de scanner le QR code, et notre outil vous donne instantanément les informations avec une option avancée pour copier le texte/lien, ouvrir si un lien est détecté, ou enregistrer automatiquement si un contact est détecté.',
            'Aucune installation requise : Vous n’avez pas besoin d’installer une application séparée pour utiliser notre scanner de QR code. Vous pouvez accéder gratuitement à cet outil depuis votre navigateur local.',
            'Accès multiplateforme : Vous pouvez y accéder sur n’importe quel appareil. Pas d’inquiétude concernant la version du système d’exploitation ou d’autres exigences. Cet outil est pris en charge sur toutes les versions et tous les appareils.',
            'Tous les formats pris en charge : Tous les formats de données pouvant être stockés dans un QR code, y compris le texte brut, le WiFi, les URL, les contacts, Gmail et Google Maps, etc., sont pris en charge par notre outil.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Guide étape par étape :',
          steps: [
            {
              heading: '1. Tout d’abord, choisissez une méthode pour scanner le QR code. Il existe les deux méthodes suivantes :',
              subSteps: [
                {
                  heading: 'i. Méthode caméra',
                  paragraphs: [
                    'Vous pouvez scanner le QR code avec la caméra de votre appareil, même si vous utilisez un ordinateur portable, un PC, ou tout appareil prenant en charge une caméra simple. En cliquant sur le bouton “Démarrer la caméra”, une demande d’autorisation apparaîtra ; autorisez ce site à utiliser votre caméra pour le scan QR. Si vous l’avez refusée par erreur ou si la demande n’apparaît pas, vous pouvez accorder l’accès manuellement en suivant ces étapes :',
                  ],
                  notes: [
                    '➔ Pour Chrome (Android / Desktop) :',
                    '1. Cliquez sur les trois points',
                    '2. Allez dans Paramètres',
                    '3. (Ignorez cette étape sur Android) Confidentialité et sécurité',
                    '4. Cliquez sur Paramètres du site',
                    '5. Ensuite, dans la section des autorisations, cliquez sur Caméra',
                    '6. Recherchez l’URL de notre site : https://photremium.com/qr-code-scanner',
                    '7. Autorisez la caméra dans le menu déroulant.',
                    '➔ Pour Safari (iPhone / iOS) :',
                    '1. Touchez l’icône AA ou Réglages du site web dans la barre d’adresse.',
                    '2. Sélectionnez Réglages du site web.',
                    '3. Touchez Caméra et choisissez Autoriser.',
                    '4. Si c’est toujours bloqué : allez dans Réglages iPhone > Safari > Caméra et réglez sur Demander ou Autoriser.',
                  ],
                },
                {
                  heading: 'ii. Méthode galerie',
                  paragraphs: [
                    'Vous pouvez téléverser l’image d’un QR code pour accéder à ses informations. Cliquez sur le bouton “Scanner depuis la galerie”, et l’explorateur de fichiers s’ouvrira. Ensuite, sélectionnez l’image du QR code. Tous les formats d’image sont pris en charge, tels que .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz et .xbm, etc.',
                  ],
                },
              ],
            },
            {
              heading: '2. Lorsque vous sélectionnez le QR code, toutes les informations sont affichées ; vous permettant de copier, partager ou ouvrir le lien s’il est détecté. Vous pouvez aussi scanner à nouveau si vous le souhaitez.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Avantages du scanner de QR code:.',
          paragraphs: [
            'Le scanner de QR code offre plusieurs avantages dans ce monde numérique. Il rend les paiements, les vérifications et l’accès à l’information faciles et rapides, même en mode hors ligne.',
          ],
          bullets: [
            'Accès instantané à l’information : Scanner le QR code fournit les informations en quelques millisecondes. Il décode les motifs, détecte les erreurs et les corrige très rapidement, offrant à l’utilisateur une expérience extrêmement rapide.',
            'Communication fluide : À l’ère du numérique, il existe un besoin urgent de communication rapide et sécurisée pour de petites informations comme les détails bancaires et les informations produit, etc. Le scanner de QR code résout ce problème, car les paiements se font en scannant un QR code. De plus, Google vérifie les téléphones via QR lors de la création d’un nouveau compte sur ordinateur portable.',
            'E-Tickets : Dans les gares routières, les gares ferroviaires ou les aéroports, vous pouvez vérifier vos billets facilement sans attendre longtemps en file. De plus, des scanners de QR code sont installés à plusieurs endroits dans les aéroports pour éviter les files d’attente. Cela réduit aussi le besoin en personnel, et permet automatiquement d’économiser le budget de la compagnie aérienne.',
            'Authentification des produits : Les marques avancées et haut de gamme placent un QR code sur leurs produits. Le client peut scanner ce QR code pour vérifier l’authenticité du produit, qu’il soit original ou non.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Flouter les Visages — Masquer les visages dans les images en ligne | photremium.com',
      uploadDesc: 'Floutez automatiquement les visages dans les images avec la reconnaissance faciale par IA. Gratuit, rapide et privé.',
      uploadKeywords: 'flouter visage, masquer visages, reconnaissance faciale',
      workspaceTitle: 'Flouter les Visages — photremium.com',
      workspaceDesc: 'Floutez automatiquement les visages dans les images. 100% gratuit, rapide et privé.',
      workspaceKeywords: 'flouter visage',
    },
    title: 'Flouter les Visages',
    desc: 'Détectez et floutez automatiquement les visages dans les images pour plus de confidentialité.',
    toBlurFaces: 'Flouter les visages',
    autoDetection: 'Détection automatique',
    autoDetectionDesc: 'La reconnaissance faciale par IA trouve tous les visages instantanément',
    customBlur: 'Flou personnalisé',
    customBlurDesc: 'Personnalisez l\'intensité, la forme et le style du flou',
    private100: '100% Privé',
    private100Desc: 'Tout le traitement se fait localement dans votre navigateur',
    blurTools: 'Outils de flou',
    faces: 'Visages',
    faceDetection: 'Détection des visages',
    detecting: 'Détection...',
    autoDetectFaces: 'Détecter automatiquement les visages',
    exitManualMode: 'Quitter le mode manuel',
    manualSelect: 'Sélection manuelle',
    nFaceRegions: '{n} région(s) de visage trouvée(s)',
    noFacesDetected: 'Aucun visage détecté — utiliser le mode manuel',
    manualHint: 'Cliquez et faites glisser sur l\'image pour dessiner un rectangle sur la zone à flouter.',
    blurType: 'Type de flou',
    blur: 'Flou',
    emoji: 'Emoji',
    blurIntensity: 'Intensité du flou',
    strength: 'Intensité',
    blurShape: 'Forme du flou',
    rectangle: 'Rectangle',
    ellipse: 'Ellipse',
    circle: 'Cercle',
    chooseEmoji: 'Choisir un emoji',
    blurRegionsN: 'Régions de flou ({n})',
    faceN: 'Visage {n}',
    manualRegionN: 'Région manuelle {n}',
    manualN: 'Manuel {n}',
    clearAllRegions: 'Effacer toutes les régions',
    processingDots: 'Traitement...',
    downloadBlurred: 'Télécharger l\'image floutée',
    downloadNImages: 'Télécharger {n} images',
    downloadDialogTitle: 'Toutes les images ne sont pas modifiées',
    downloadDialogText: 'Vous avez modifié {edited} sur {total} images.',
    downloadAll: 'Tout télécharger',
    removeRegion: 'Supprimer la région',
    region: 'Région',
    notAllEdited: 'Toutes les images ne sont pas modifiées',
    editedXofY: 'Vous avez modifié {edited} sur {total} images.',
    nextImage: 'Image suivante',
  },

  faqData: {
    imageConverter: [
      { q: 'Quels formats d\'image sont pris en charge pour la conversion ?', a: 'Nous prenons en charge JPG, PNG, WEBP, SVG, GIF, BMP, ICO et TIFF. Vous pouvez convertir entre ces formats instantanément dans votre navigateur.' },
      { q: 'La qualité de l\'image sera-t-elle affectée lors de la conversion ?', a: 'Pour les formats sans perte comme PNG, la qualité est totalement préservée. Pour les formats avec perte comme JPG et WEBP, nous utilisons des paramètres d\'encodage optimisés.' },
      { q: 'Y a-t-il une limite de taille ou de quantité de fichiers ?', a: 'Il n\'y a pas de limite stricte. Vous pouvez télécharger plusieurs images à la fois et les convertir en lot. Tout s\'exécute localement dans votre navigateur.' },
      { q: 'Mes données sont-elles sécurisées ? Les images sont-elles envoyées à un serveur ?', a: 'Absolument. Tout le traitement se fait à 100 % dans votre navigateur. Vos images ne quittent jamais votre appareil.' },
      { q: 'Puis-je convertir des PNG transparents en JPG ?', a: 'Oui. Comme JPG ne prend pas en charge la transparence, les zones transparentes seront remplies avec un fond blanc par défaut.' },
    ],
    imageCompressor: [
      { q: 'La compression d\'image réduit-elle sa qualité ?', a: 'Non, compresser une image n\'affecte pas sa qualité tant que vous restez dans les limites recommandées. Des indicateurs vous guident : i. Compression de 1 à 40 % : indicateur vert avec le message « Bonne qualité ». ii. Compression de 41 à 60 % : indicateur jaune avec « Qualité normale ». Cette plage est recommandée pour de bons résultats. iii. Compression de 61 à 100 % : alerte rouge avec « Mauvaise qualité ». Dans cette plage, la perte de qualité peut devenir visible.' },
      { q: 'Quels formats d\'image sont pris en charge pour la compression ?', a: 'Notre outil prend en charge tous les formats suivants :\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Puis-je compresser plusieurs images en même temps ?', a: 'Oui, tout à fait. Vous pouvez compresser plusieurs images (même 100+) en une seule fois si votre appareil le permet. Comme la compression utilise les ressources de votre système, les gros lots fonctionnent mieux sur un appareil performant. Sur un appareil plus modeste, vous pouvez compresser par lots : l\'outil reste gratuit, sans limite d\'utilisation.' },
      { q: 'Stockez-vous ou envoyez-vous nos images sur vos serveurs ?', a: 'Non. Nous ne téléchargeons ni ne stockons vos images sur nos serveurs. Tout est compressé localement dans votre navigateur. Vos images ne quittent jamais votre appareil.' },
      { q: 'Cet outil de compression d\'images est-il gratuit ?', a: 'Oui. Notre compresseur d\'images est totalement gratuit, pour toujours. Aucun paiement n\'est demandé, aucun frais caché, et toutes les fonctionnalités — y compris la compression multiple — sont gratuites.' },
    ],
    cropImage: [
      { q: 'Le recadrage de l’image réduira-t-il sa qualité ?', a: 'Non, le recadrage de l’image n’affectera jamais du tout la qualité visuelle de l’image. Le recadrage de l’image supprime simplement les parties indésirables. Il ne modifie jamais les pixels de la partie de l’image à recadrer. Ainsi, vous pouvez recadrer vos images dans leur qualité d’origine sans aucun dommage des pixels.' },
      { q: 'Quels formats d’image sont pris en charge pour l’outil de recadrage d’image ?', a: 'Vous pouvez sélectionner n’importe quelle image de n’importe quel format, car notre outil de recadrage d’image prend en charge presque tous les formats d’image. Ils sont listés ci-dessous :\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Mes images sont-elles envoyées sur votre serveur ?', a: 'Non, tout le traitement sera effectué dans votre navigateur local. Vos images ne seront jamais envoyées sur notre serveur car elles ne quittent jamais votre appareil. Ainsi, vous pouvez recadrer vos images personnelles avec notre outil de recadrage d’image sans aucun risque.' },
      { q: 'Puis-je recadrer plusieurs images à la fois ?', a: 'Oui, vous pouvez recadrer plusieurs images (même 100+) à la fois si votre système le permet. Comme le recadrage des images utilise les ressources de votre système, si vous avez un ordinateur portable, un PC ou un mobile haute performance, vous pouvez recadrer de nombreuses images à la fois. Si vous avez un appareil d’entrée de gamme, vous pouvez recadrer les images par lots, car cet outil est gratuit même si vous recadrez plusieurs images à la fois.' },
      { q: 'Cet outil de recadrage d’image est-il gratuit ?', a: 'Oui, cet outil de recadrage d’image est totalement gratuit pour toujours. Vous pouvez accéder à cet outil n’importe où, n’importe quand, et sur n’importe quel appareil. Vous bénéficierez non seulement d’un design responsive pour tous les appareils, mais il ne vous sera jamais demandé de payer pour une fonctionnalité premium. Toutes les fonctionnalités sont totalement gratuites sans frais cachés.' },
    ],
    resizeImage: [
      { q: 'Puis-je redimensionner plusieurs images à la fois ?', a: 'Absolument, notre outil vous permet de redimensionner plusieurs images en une seule fois. Il vous suffit d’envoyer autant d’images que votre appareil peut gérer, et notre moteur IA redimensionnera toutes vos images d’un coup. Si votre appareil est peu puissant, redimensionnez par lots pour éviter les ralentissements. Le redimensionnement utilise les ressources de l’appareil afin d’éviter tout envoi serveur et de protéger votre confidentialité.' },
      { q: 'Cet outil de redimensionnement est-il gratuit ?', a: 'Oui, cet outil est gratuit à vie. Vous ne serez jamais invité à payer un abonnement pour débloquer des fonctionnalités premium. Aucun frais caché n’est demandé pour télécharger vos images redimensionnées.' },
      { q: 'Le redimensionnement réduit-il la qualité de l’image ?', a: '✅Decrease Size (downscale): Réduire la taille d’une image ne réduit pas sa qualité visuelle. Au contraire, l’image redimensionnée peut paraître plus nette que l’originale. Donc, redimensionner vers des dimensions plus petites ne réduit pas la qualité.\n❌Increase Size (upscale): Agrandir l’image au-delà de sa taille d’origine peut affecter sa qualité visuelle. L’impact dépend de l’ampleur de l’agrandissement. Plus vous agrandissez, plus la qualité baisse.' },
      { q: 'Cet outil de redimensionnement est-il sûr à utiliser ?', a: 'Oui, notre outil est totalement sûr, en particulier pour les images personnelles et privées, car toutes les images sont traitées localement. Aucune de vos données ne quitte votre appareil pendant le traitement. Vous pouvez redimensionner vos images personnelles sans risque.' },
      { q: 'Quels formats d’image sont pris en charge ?', a: 'Tous les formats d’image sont pris en charge par notre outil. Vous pouvez sélectionner des images dans ces formats :\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Comment fonctionne la suppression de l\'arrière-plan ?', a: 'Nous utilisons un modèle d\'IA avancé s\'exécutant directement dans votre navigateur pour détecter le sujet et le séparer de l\'arrière-plan.' },
      { q: 'Cela fonctionne-t-il avec des arrière-plans complexes ?', a: 'Oui. Le modèle d\'IA gère une grande variété de scènes. Les meilleurs résultats sont obtenus avec un contraste clair entre le sujet et l\'arrière-plan.' },
      { q: 'Puis-je supprimer l\'arrière-plan de plusieurs images à la fois ?', a: 'Oui. Téléchargez plusieurs images et l\'outil les traitera séquentiellement. Téléchargez tous les résultats en ZIP.' },
      { q: 'Quel est le format de sortie ?', a: 'La sortie est toujours un fichier PNG avec un arrière-plan transparent.' },
      { q: 'Mes images sont-elles envoyées à un serveur ?', a: 'Non. Le modèle d\'IA s\'exécute entièrement dans votre navigateur via WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. L\'outil de filigrane Photremium est-il entièrement gratuit ?', a: 'Oui, l\'outil de filigrane sur photremium.com/watermark-image est totalement gratuit, sans compte et sans abonnement. Vous pouvez filigraner une seule image ou des lots entiers sans paywall, sans inscription obligatoire et sans limite de téléchargement. L\'outil est financé par la valeur globale de Photremium, pas par le blocage des fonctions essentielles.' },
      { q: '2. Combien d\'images puis-je filigraner en une fois ?', a: 'L\'outil prend en charge le filigranage par lots. Vous pouvez glisser-déposer un dossier complet dans la zone d\'upload ou sélectionner des dizaines de fichiers via Ctrl+Click. La colonne de miniatures à gauche affiche tout, et en cliquant sur "Watermark & Download All", l\'outil rend chaque image puis les regroupe dans un ZIP (ou les télécharge séparément — selon votre choix). En pratique, la limite vient de la mémoire disponible de votre appareil, pas d\'un plafond artificiel.' },
      { q: '3. Quels formats sont pris en charge en entrée et en sortie ?', a: 'L\'entrée accepte les formats que le File API du navigateur sait gérer — généralement JPEG, JPG, PNG, WEBP, GIF (statique), BMP et SVG. La sortie conserve le format d\'origine : un PNG reste un PNG, un JPEG reste un JPEG avec une qualité de 0.95. Cela évite de convertir par erreur un PNG sans perte en JPG avec perte.' },
      { q: '4. Le filigrane gardera-t-il le même rendu sur des images de résolutions différentes ?', a: 'Oui, grâce au moteur de repositionnement proportionnel. Quand vous travaillez sur un lot d\'images de tailles différentes, le filigrane est créé sur l\'image de référence. À l\'export, l\'algorithme calcule la position de chaque calque en proportion du centre de l\'image et applique la même proportion à chaque image cible. La taille est également mise à l\'échelle proportionnellement (selon le plus petit ratio largeur/hauteur) pour éviter tout débordement. Résultat : un filigrane cohérent en taille et position sur tout le lot.' },
      { q: '5. Puis-je utiliser mon propre logo ou une signature comme filigrane ?', a: 'Oui. Le bouton "Add Image" dans le panneau droit permet de charger une image comme calque de filigrane. Les PNG avec transparence sont idéaux : la transparence est conservée et seul le logo est visible. Vous pouvez redimensionner via les coins (ratio conservé), faire pivoter, retourner, ajuster l\'opacité, et même ajouter un contour ou des coins arrondis. Beaucoup d\'utilisateurs préparent une version transparente de leur logo dédiée au filigrane.' },
      { q: '6. Comment rendre le filigrane transparent ou semi-transparent ?', a: 'Sélectionnez le calque sur la toile. Dans la barre d\'outils, vous verrez le contrôle d\'opacité en pourcentage — vous pouvez saisir une valeur ou faire glisser. Pour un rendu discret et professionnel, 30–50% est un bon intervalle. Pour un filigrane plus visible, 70–80% fonctionne bien. Vous pouvez aussi basculer la visibilité dans le gestionnaire de calques (icône œil) pour comparer.' },
      { q: '7. Puis-je ajouter plusieurs filigranes sur une même image ?', a: 'Oui — le système de calques permet un nombre illimité de filigranes, chacun configurable indépendamment. Vous pouvez avoir un texte de copyright en bas à droite, un logo en haut à gauche et un motif "SAMPLE" en tuilage. Chaque calque possède sa propre opacité, rotation, position, taille et style. Le gestionnaire de calques organise tout et permet d\'activer/désactiver sans supprimer pour tester différentes variantes.' },
      { q: '8. Que fait la fonction de tuilage et quand l\'utiliser ?', a: 'Le tuilage répète le filigrane en grille sur toute l\'image. Grid 2×2 place quatre copies, Grid 3×3 en place neuf. Le réglage d\'espacement contrôle la distance entre les copies. C\'est utile quand vous voulez rendre l\'image inutilisable sans autorisation — un filigrane dans un coin peut être facilement recadré, alors qu\'un motif complet est difficile à retirer sans dégrader l\'image. C\'est courant pour les aperçus de contrat, les brouillons client ou les contenus avant paiement.' },
      { q: '9. L\'outil fonctionne-t-il sur mobile et tablette ?', a: 'Oui, l\'outil est totalement responsive et pensé pour le mobile. Sous 900 px, la mise en page se superpose : la bande de miniatures devient horizontale, la toile reste au centre et les réglages apparaissent en panneau inférieur via un bouton flottant. Toutes les interactions — glisser, redimensionner, faire pivoter — sont tactiles. Les poignées sont un peu plus grandes sur mobile (16×16 px) pour faciliter la manipulation.' },
      { q: '10. Mes données sont-elles privées ? Les photos sont-elles envoyées à un serveur ?', a: 'Vos images ne quittent jamais votre appareil. Tout le flux — chargement, rendu, export — s\'exécute dans le navigateur avec JavaScript et l\'HTML5 Canvas API. La File API charge le fichier en mémoire, les calques sont dessinés sur une canvas hors écran, puis les pixels sont convertis en Blob pour un téléchargement local. Aucune requête réseau ne contient vos données d\'image. Un garde-fou empêche également les pertes : si vous quittez la page avec des images chargées, le navigateur demande confirmation.' },
    ],
    qrCodeGenerator: [
      { q: 'Ce code QR expire-t-il ?', a: 'Non, ces codes QR n’expirent pas et garantissent un support à vie. Comme ils stockent des instructions codées en dur sous forme de bits dans des modules carrés, les informations qu’ils contiennent ne peuvent pas être supprimées. Vous pouvez accéder aux informations simplement en les scannant avec n’importe quelle caméra, même après des années.' },
      { q: 'Pourquoi mon code QR ne se scanne-t-il pas ?', a: 'Votre code QR peut ne pas être scanné pour les raisons suivantes : i. Faible contraste : si vous choisissez des couleurs d’arrière-plan et d’avant-plan trop similaires, la visibilité du code QR diminue et le scan peut échouer. Notre outil vous guide pendant la personnalisation en cas de faible contraste ou d’autres problèmes de scan. ii. Données trop volumineuses : si vous générez un code QR pour un texte très long, il devient très complexe et peut être difficile à scanner. Un validateur de longueur de texte vous guide sur la longueur optimale pendant la génération du code QR. iii. Impression floue : assurez-vous de télécharger votre code QR en haute résolution, comme PNG ou SVG, formats déjà pris en charge par notre outil.' },
      { q: 'Puis-je ajouter un logo dans le code QR ?', a: 'Absolument, vous pouvez ajouter un logo personnalisé ou en sélectionner un dans la bibliothèque de logos intégrée pour votre code QR. Le logo sélectionné sera automatiquement ajusté au centre du code QR.' },
      { q: 'Comment puis-je scanner le code QR ?', a: 'Vous pouvez scanner le code QR avec la caméra de votre mobile. Mais pour la redirection automatique vers les liens et d’autres fonctionnalités avancées, vous pouvez utiliser gratuitement notre scanner QR via https://photremium.com/qr-code-scanner.' },
      { q: 'Combien de codes QR puis-je générer gratuitement ?', a: 'ILLIMITÉ ! Vous pouvez générer plusieurs codes QR gratuitement. Toutes les fonctionnalités, personnalisations et modèles sont gratuits pour toujours. Aucun abonnement n’est nécessaire pour profiter des fonctionnalités premium.' },
      { q: 'Dois-je me connecter/m’inscrire pour générer un code QR ?', a: 'Non. Entrez simplement votre texte, générez le code QR et téléchargez-le après personnalisation. Aucune connexion ni inscription n’est nécessaire, car toutes les fonctionnalités sont accessibles gratuitement.' },
    ],
    qrCodeScanner: [
      { q: 'Puis-je scanner un QR code depuis des images enregistrées et des captures d’écran ?', a: '**Oui**, vous pouvez scanner un QR code depuis des images enregistrées ou des captures d’écran. Notre scanner de QR code https://photremium.com/qr-code-scanner vous permet de scanner un QR code depuis la galerie. Il vous suffit de sélectionner l’image, et vous obtiendrez toutes les informations décodées de ce QR code.' },
      { q: 'Dois-je installer une application pour utiliser le scanner de QR code ?', a: '**Non**, notre scanner de QR code basé sur le web vous permet de scanner un QR code sans installer d’application. Vous pouvez accéder gratuitement à notre scanner avancé sur n’importe quel appareil.' },
      { q: 'Pourquoi le scanner ne reconnaît-il pas le QR code ?', a: 'Votre QR code n’est pas scanné pour l’une des raisons suivantes : i. Lumière insuffisante : scanner un QR code dans un environnement sombre peut causer des difficultés. Activez la lampe torche et augmentez la luminosité si vous scannez depuis un écran. ii. Distance : scanner un QR code à une distance inappropriée peut aussi causer des problèmes. La distance optimale pour scanner un QR code est d’environ 10 pouces (25 cm). iii. Lentilles de caméra sales : un QR code peut aussi échouer à cause de lentilles sales. Nettoyez les lentilles avant de scanner. “Vous voyez une grille carrée dans le scanner ? Placez simplement le QR code à l’intérieur pour le scanner correctement.”' },
      { q: 'Cet outil peut-il scanner un QR code inversé ou coloré ?', a: '**Oui**, vous pouvez scanner un QR code dans n’importe quelle couleur ou orientation. Cependant, si le contraste entre la couleur de fond et la couleur de premier plan est faible, cela peut rendre le scan difficile.' },
      { q: 'Cet outil est-il gratuit ?', a: '**Oui**, cet outil est totalement gratuit. Vous pouvez scanner un nombre illimité de QR codes gratuitement pour toujours.' },
    ],
    faceBlur: [
      { q: 'Comment fonctionne la détection des visages ?', a: 'Nous utilisons un modèle de détection de visages par IA qui s\'exécute directement dans votre navigateur. Il identifie les visages dans l\'image.' },
      { q: 'Puis-je choisir quels visages flouter ?', a: 'Oui. Après la détection, chaque région de visage est mise en évidence et vous pouvez sélectionner ceux à flouter et ajuster l\'intensité.' },
      { q: 'Quels styles de flou sont disponibles ?', a: 'Vous pouvez choisir entre le flou gaussien, la pixelisation ou un remplissage de couleur unie, avec une intensité entièrement réglable.' },
      { q: 'Puis-je flouter des visages dans plusieurs images à la fois ?', a: 'Oui. Téléchargez plusieurs images, configurez les régions de flou et téléchargez toutes les images traitées.' },
      { q: 'Mes photos sont-elles envoyées à un serveur distant ?', a: 'Non. Le modèle d\'IA s\'exécute dans votre navigateur via WebAssembly. Vos photos ne sont jamais téléchargées.' },
    ],
    photoEditor: [
      { q: 'Quelles fonctions d\'édition sont disponibles ?', a: 'Vous pouvez ajuster la luminosité, le contraste, la saturation, appliquer des filtres, ajouter du texte, des superpositions, des cadres, des autocollants et bien plus.' },
      { q: 'Puis-je annuler et rétablir des modifications ?', a: 'Oui. L\'éditeur prend en charge l\'historique complet d\'annulation/rétablissement.' },
      { q: 'Quels formats de fichier puis-je modifier et exporter ?', a: 'Vous pouvez modifier JPG, PNG, WEBP et d\'autres formats courants. L\'image modifiée peut être exportée dans le format et la qualité de votre choix.' },
      { q: 'L\'éditeur fonctionne-t-il sur mobile ?', a: 'Oui. L\'éditeur est entièrement responsive et tactile.' },
      { q: 'Mes images sont-elles stockées sur vos serveurs ?', a: 'Non. Toute l\'édition est faite localement. Vos images ne quittent jamais votre appareil.' },
    ],
  },
};

export default fr;
